// This client was generated by Platformatic from an OpenAPI specification.

import type { Api } from './api-types'
import type * as Types from './api-types'

// The base URL for the API. This can be overridden by calling `setBaseUrl`.
let baseUrl = ''
// The default headers to send within each request. This can be overridden by calling `setDefaultHeaders`.
let defaultHeaders = {}

function sanitizeUrl(url: string) : string {
  if (url.endsWith('/')) { return url.slice(0, -1) } else { return url }
}
export const setBaseUrl = (newUrl: string) : void => { baseUrl = sanitizeUrl(newUrl) }

export const setDefaultHeaders = (headers: Object): void => { defaultHeaders = headers }

type JSON = Record<string, unknown>
/* @ts-ignore */
function headersToJSON(headers: Headers): JSON {
  const output: JSON = {}
  headers.forEach((value, key) => {
    output[key] = value
  })
  return output
}

const _getV1WorkCentreCategories = async (url: string, request: Types.GetV1WorkCentreCategoriesRequest): Promise<Types.GetV1WorkCentreCategoriesResponses> => {
  const queryParameters: (keyof Types.GetV1WorkCentreCategoriesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-centre-categories/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkCentreCategories: Api['getV1WorkCentreCategories'] = async (request: Types.GetV1WorkCentreCategoriesRequest): Promise<Types.GetV1WorkCentreCategoriesResponses> => {
  return await _getV1WorkCentreCategories(baseUrl, request)
}
const _postV1WorkCentreCategories = async (url: string, request: Types.PostV1WorkCentreCategoriesRequest): Promise<Types.PostV1WorkCentreCategoriesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-centre-categories/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WorkCentreCategories: Api['postV1WorkCentreCategories'] = async (request: Types.PostV1WorkCentreCategoriesRequest): Promise<Types.PostV1WorkCentreCategoriesResponses> => {
  return await _postV1WorkCentreCategories(baseUrl, request)
}
const _getV1WorkCentreCategoriesId = async (url: string, request: Types.GetV1WorkCentreCategoriesIdRequest): Promise<Types.GetV1WorkCentreCategoriesIdResponses> => {
  const queryParameters: (keyof Types.GetV1WorkCentreCategoriesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-centre-categories/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkCentreCategoriesId: Api['getV1WorkCentreCategoriesId'] = async (request: Types.GetV1WorkCentreCategoriesIdRequest): Promise<Types.GetV1WorkCentreCategoriesIdResponses> => {
  return await _getV1WorkCentreCategoriesId(baseUrl, request)
}
const _putV1WorkCentreCategoriesId = async (url: string, request: Types.PutV1WorkCentreCategoriesIdRequest): Promise<Types.PutV1WorkCentreCategoriesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-centre-categories/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1WorkCentreCategoriesId: Api['putV1WorkCentreCategoriesId'] = async (request: Types.PutV1WorkCentreCategoriesIdRequest): Promise<Types.PutV1WorkCentreCategoriesIdResponses> => {
  return await _putV1WorkCentreCategoriesId(baseUrl, request)
}
const _deleteV1WorkCentreCategoriesId = async (url: string, request: Types.DeleteV1WorkCentreCategoriesIdRequest): Promise<Types.DeleteV1WorkCentreCategoriesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-centre-categories/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1WorkCentreCategoriesId: Api['deleteV1WorkCentreCategoriesId'] = async (request: Types.DeleteV1WorkCentreCategoriesIdRequest): Promise<Types.DeleteV1WorkCentreCategoriesIdResponses> => {
  return await _deleteV1WorkCentreCategoriesId(baseUrl, request)
}
const _postV1WorkCentreCategoriesSaveAsDraft = async (url: string, request: Types.PostV1WorkCentreCategoriesSaveAsDraftRequest): Promise<Types.PostV1WorkCentreCategoriesSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-centre-categories/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WorkCentreCategoriesSaveAsDraft: Api['postV1WorkCentreCategoriesSaveAsDraft'] = async (request: Types.PostV1WorkCentreCategoriesSaveAsDraftRequest): Promise<Types.PostV1WorkCentreCategoriesSaveAsDraftResponses> => {
  return await _postV1WorkCentreCategoriesSaveAsDraft(baseUrl, request)
}
const _postV1WorkCentreCategoriesImport = async (url: string, request: Types.PostV1WorkCentreCategoriesImportRequest): Promise<Types.PostV1WorkCentreCategoriesImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-centre-categories/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WorkCentreCategoriesImport: Api['postV1WorkCentreCategoriesImport'] = async (request: Types.PostV1WorkCentreCategoriesImportRequest): Promise<Types.PostV1WorkCentreCategoriesImportResponses> => {
  return await _postV1WorkCentreCategoriesImport(baseUrl, request)
}
const _getV1WorkCentreCategoriesGenerateExcel = async (url: string, request: Types.GetV1WorkCentreCategoriesGenerateExcelRequest): Promise<Types.GetV1WorkCentreCategoriesGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1WorkCentreCategoriesGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-centre-categories/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkCentreCategoriesGenerateExcel: Api['getV1WorkCentreCategoriesGenerateExcel'] = async (request: Types.GetV1WorkCentreCategoriesGenerateExcelRequest): Promise<Types.GetV1WorkCentreCategoriesGenerateExcelResponses> => {
  return await _getV1WorkCentreCategoriesGenerateExcel(baseUrl, request)
}
const _getV1Equipments = async (url: string, request: Types.GetV1EquipmentsRequest): Promise<Types.GetV1EquipmentsResponses> => {
  const queryParameters: (keyof Types.GetV1EquipmentsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Equipments: Api['getV1Equipments'] = async (request: Types.GetV1EquipmentsRequest): Promise<Types.GetV1EquipmentsResponses> => {
  return await _getV1Equipments(baseUrl, request)
}
const _postV1Equipments = async (url: string, request: Types.PostV1EquipmentsRequest): Promise<Types.PostV1EquipmentsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Equipments: Api['postV1Equipments'] = async (request: Types.PostV1EquipmentsRequest): Promise<Types.PostV1EquipmentsResponses> => {
  return await _postV1Equipments(baseUrl, request)
}
const _getV1EquipmentsId = async (url: string, request: Types.GetV1EquipmentsIdRequest): Promise<Types.GetV1EquipmentsIdResponses> => {
  const queryParameters: (keyof Types.GetV1EquipmentsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1EquipmentsId: Api['getV1EquipmentsId'] = async (request: Types.GetV1EquipmentsIdRequest): Promise<Types.GetV1EquipmentsIdResponses> => {
  return await _getV1EquipmentsId(baseUrl, request)
}
const _putV1EquipmentsId = async (url: string, request: Types.PutV1EquipmentsIdRequest): Promise<Types.PutV1EquipmentsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1EquipmentsId: Api['putV1EquipmentsId'] = async (request: Types.PutV1EquipmentsIdRequest): Promise<Types.PutV1EquipmentsIdResponses> => {
  return await _putV1EquipmentsId(baseUrl, request)
}
const _deleteV1EquipmentsId = async (url: string, request: Types.DeleteV1EquipmentsIdRequest): Promise<Types.DeleteV1EquipmentsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1EquipmentsId: Api['deleteV1EquipmentsId'] = async (request: Types.DeleteV1EquipmentsIdRequest): Promise<Types.DeleteV1EquipmentsIdResponses> => {
  return await _deleteV1EquipmentsId(baseUrl, request)
}
const _postV1EquipmentsSaveAsDraft = async (url: string, request: Types.PostV1EquipmentsSaveAsDraftRequest): Promise<Types.PostV1EquipmentsSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1EquipmentsSaveAsDraft: Api['postV1EquipmentsSaveAsDraft'] = async (request: Types.PostV1EquipmentsSaveAsDraftRequest): Promise<Types.PostV1EquipmentsSaveAsDraftResponses> => {
  return await _postV1EquipmentsSaveAsDraft(baseUrl, request)
}
const _getV1EquipmentsCategories = async (url: string, request: Types.GetV1EquipmentsCategoriesRequest): Promise<Types.GetV1EquipmentsCategoriesResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/categories`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1EquipmentsCategories: Api['getV1EquipmentsCategories'] = async (request: Types.GetV1EquipmentsCategoriesRequest): Promise<Types.GetV1EquipmentsCategoriesResponses> => {
  return await _getV1EquipmentsCategories(baseUrl, request)
}
const _getV1EquipmentsMaintenanceHistory = async (url: string, request: Types.GetV1EquipmentsMaintenanceHistoryRequest): Promise<Types.GetV1EquipmentsMaintenanceHistoryResponses> => {
  const queryParameters: (keyof Types.GetV1EquipmentsMaintenanceHistoryRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/maintenance-history?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1EquipmentsMaintenanceHistory: Api['getV1EquipmentsMaintenanceHistory'] = async (request: Types.GetV1EquipmentsMaintenanceHistoryRequest): Promise<Types.GetV1EquipmentsMaintenanceHistoryResponses> => {
  return await _getV1EquipmentsMaintenanceHistory(baseUrl, request)
}
const _postV1EquipmentsMaintenanceHistory = async (url: string, request: Types.PostV1EquipmentsMaintenanceHistoryRequest): Promise<Types.PostV1EquipmentsMaintenanceHistoryResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/maintenance-history`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1EquipmentsMaintenanceHistory: Api['postV1EquipmentsMaintenanceHistory'] = async (request: Types.PostV1EquipmentsMaintenanceHistoryRequest): Promise<Types.PostV1EquipmentsMaintenanceHistoryResponses> => {
  return await _postV1EquipmentsMaintenanceHistory(baseUrl, request)
}
const _getV1EquipmentsMaintenanceHistoryId = async (url: string, request: Types.GetV1EquipmentsMaintenanceHistoryIdRequest): Promise<Types.GetV1EquipmentsMaintenanceHistoryIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/maintenance-history/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1EquipmentsMaintenanceHistoryId: Api['getV1EquipmentsMaintenanceHistoryId'] = async (request: Types.GetV1EquipmentsMaintenanceHistoryIdRequest): Promise<Types.GetV1EquipmentsMaintenanceHistoryIdResponses> => {
  return await _getV1EquipmentsMaintenanceHistoryId(baseUrl, request)
}
const _putV1EquipmentsMaintenanceHistoryId = async (url: string, request: Types.PutV1EquipmentsMaintenanceHistoryIdRequest): Promise<Types.PutV1EquipmentsMaintenanceHistoryIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/maintenance-history/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1EquipmentsMaintenanceHistoryId: Api['putV1EquipmentsMaintenanceHistoryId'] = async (request: Types.PutV1EquipmentsMaintenanceHistoryIdRequest): Promise<Types.PutV1EquipmentsMaintenanceHistoryIdResponses> => {
  return await _putV1EquipmentsMaintenanceHistoryId(baseUrl, request)
}
const _deleteV1EquipmentsMaintenanceHistoryId = async (url: string, request: Types.DeleteV1EquipmentsMaintenanceHistoryIdRequest): Promise<Types.DeleteV1EquipmentsMaintenanceHistoryIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/maintenance-history/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1EquipmentsMaintenanceHistoryId: Api['deleteV1EquipmentsMaintenanceHistoryId'] = async (request: Types.DeleteV1EquipmentsMaintenanceHistoryIdRequest): Promise<Types.DeleteV1EquipmentsMaintenanceHistoryIdResponses> => {
  return await _deleteV1EquipmentsMaintenanceHistoryId(baseUrl, request)
}
const _patchV1EquipmentsElectricityConsumptionId = async (url: string, request: Types.PatchV1EquipmentsElectricityConsumptionIdRequest): Promise<Types.PatchV1EquipmentsElectricityConsumptionIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/electricity-consumption/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1EquipmentsElectricityConsumptionId: Api['patchV1EquipmentsElectricityConsumptionId'] = async (request: Types.PatchV1EquipmentsElectricityConsumptionIdRequest): Promise<Types.PatchV1EquipmentsElectricityConsumptionIdResponses> => {
  return await _patchV1EquipmentsElectricityConsumptionId(baseUrl, request)
}
const _deleteV1EquipmentsElectricityConsumptionId = async (url: string, request: Types.DeleteV1EquipmentsElectricityConsumptionIdRequest): Promise<Types.DeleteV1EquipmentsElectricityConsumptionIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/electricity-consumption/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1EquipmentsElectricityConsumptionId: Api['deleteV1EquipmentsElectricityConsumptionId'] = async (request: Types.DeleteV1EquipmentsElectricityConsumptionIdRequest): Promise<Types.DeleteV1EquipmentsElectricityConsumptionIdResponses> => {
  return await _deleteV1EquipmentsElectricityConsumptionId(baseUrl, request)
}
const _postV1EquipmentsElectricityConsumption = async (url: string, request: Types.PostV1EquipmentsElectricityConsumptionRequest): Promise<Types.PostV1EquipmentsElectricityConsumptionResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/electricity-consumption`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1EquipmentsElectricityConsumption: Api['postV1EquipmentsElectricityConsumption'] = async (request: Types.PostV1EquipmentsElectricityConsumptionRequest): Promise<Types.PostV1EquipmentsElectricityConsumptionResponses> => {
  return await _postV1EquipmentsElectricityConsumption(baseUrl, request)
}
const _patchV1EquipmentsVoltageInspectionId = async (url: string, request: Types.PatchV1EquipmentsVoltageInspectionIdRequest): Promise<Types.PatchV1EquipmentsVoltageInspectionIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/voltage-inspection/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1EquipmentsVoltageInspectionId: Api['patchV1EquipmentsVoltageInspectionId'] = async (request: Types.PatchV1EquipmentsVoltageInspectionIdRequest): Promise<Types.PatchV1EquipmentsVoltageInspectionIdResponses> => {
  return await _patchV1EquipmentsVoltageInspectionId(baseUrl, request)
}
const _deleteV1EquipmentsVoltageInspectionId = async (url: string, request: Types.DeleteV1EquipmentsVoltageInspectionIdRequest): Promise<Types.DeleteV1EquipmentsVoltageInspectionIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/voltage-inspection/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1EquipmentsVoltageInspectionId: Api['deleteV1EquipmentsVoltageInspectionId'] = async (request: Types.DeleteV1EquipmentsVoltageInspectionIdRequest): Promise<Types.DeleteV1EquipmentsVoltageInspectionIdResponses> => {
  return await _deleteV1EquipmentsVoltageInspectionId(baseUrl, request)
}
const _postV1EquipmentsVoltageInspection = async (url: string, request: Types.PostV1EquipmentsVoltageInspectionRequest): Promise<Types.PostV1EquipmentsVoltageInspectionResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/voltage-inspection`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1EquipmentsVoltageInspection: Api['postV1EquipmentsVoltageInspection'] = async (request: Types.PostV1EquipmentsVoltageInspectionRequest): Promise<Types.PostV1EquipmentsVoltageInspectionResponses> => {
  return await _postV1EquipmentsVoltageInspection(baseUrl, request)
}
const _getV1EquipmentsFailures = async (url: string, request: Types.GetV1EquipmentsFailuresRequest): Promise<Types.GetV1EquipmentsFailuresResponses> => {
  const queryParameters: (keyof Types.GetV1EquipmentsFailuresRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/failures?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1EquipmentsFailures: Api['getV1EquipmentsFailures'] = async (request: Types.GetV1EquipmentsFailuresRequest): Promise<Types.GetV1EquipmentsFailuresResponses> => {
  return await _getV1EquipmentsFailures(baseUrl, request)
}
const _postV1EquipmentsFailures = async (url: string, request: Types.PostV1EquipmentsFailuresRequest): Promise<Types.PostV1EquipmentsFailuresResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/failures`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1EquipmentsFailures: Api['postV1EquipmentsFailures'] = async (request: Types.PostV1EquipmentsFailuresRequest): Promise<Types.PostV1EquipmentsFailuresResponses> => {
  return await _postV1EquipmentsFailures(baseUrl, request)
}
const _getV1EquipmentsFailuresId = async (url: string, request: Types.GetV1EquipmentsFailuresIdRequest): Promise<Types.GetV1EquipmentsFailuresIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/failures/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1EquipmentsFailuresId: Api['getV1EquipmentsFailuresId'] = async (request: Types.GetV1EquipmentsFailuresIdRequest): Promise<Types.GetV1EquipmentsFailuresIdResponses> => {
  return await _getV1EquipmentsFailuresId(baseUrl, request)
}
const _putV1EquipmentsFailuresId = async (url: string, request: Types.PutV1EquipmentsFailuresIdRequest): Promise<Types.PutV1EquipmentsFailuresIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/failures/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1EquipmentsFailuresId: Api['putV1EquipmentsFailuresId'] = async (request: Types.PutV1EquipmentsFailuresIdRequest): Promise<Types.PutV1EquipmentsFailuresIdResponses> => {
  return await _putV1EquipmentsFailuresId(baseUrl, request)
}
const _deleteV1EquipmentsFailuresId = async (url: string, request: Types.DeleteV1EquipmentsFailuresIdRequest): Promise<Types.DeleteV1EquipmentsFailuresIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/failures/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1EquipmentsFailuresId: Api['deleteV1EquipmentsFailuresId'] = async (request: Types.DeleteV1EquipmentsFailuresIdRequest): Promise<Types.DeleteV1EquipmentsFailuresIdResponses> => {
  return await _deleteV1EquipmentsFailuresId(baseUrl, request)
}
const _postV1EquipmentsFailuresSaveAsDraft = async (url: string, request: Types.PostV1EquipmentsFailuresSaveAsDraftRequest): Promise<Types.PostV1EquipmentsFailuresSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/failures/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1EquipmentsFailuresSaveAsDraft: Api['postV1EquipmentsFailuresSaveAsDraft'] = async (request: Types.PostV1EquipmentsFailuresSaveAsDraftRequest): Promise<Types.PostV1EquipmentsFailuresSaveAsDraftResponses> => {
  return await _postV1EquipmentsFailuresSaveAsDraft(baseUrl, request)
}
const _patchV1EquipmentsFailuresUpdateStatusId = async (url: string, request: Types.PatchV1EquipmentsFailuresUpdateStatusIdRequest): Promise<Types.PatchV1EquipmentsFailuresUpdateStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/failures/update-status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1EquipmentsFailuresUpdateStatusId: Api['patchV1EquipmentsFailuresUpdateStatusId'] = async (request: Types.PatchV1EquipmentsFailuresUpdateStatusIdRequest): Promise<Types.PatchV1EquipmentsFailuresUpdateStatusIdResponses> => {
  return await _patchV1EquipmentsFailuresUpdateStatusId(baseUrl, request)
}
const _postV1EquipmentsImport = async (url: string, request: Types.PostV1EquipmentsImportRequest): Promise<Types.PostV1EquipmentsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1EquipmentsImport: Api['postV1EquipmentsImport'] = async (request: Types.PostV1EquipmentsImportRequest): Promise<Types.PostV1EquipmentsImportResponses> => {
  return await _postV1EquipmentsImport(baseUrl, request)
}
const _getV1EquipmentsGenerateExcel = async (url: string, request: Types.GetV1EquipmentsGenerateExcelRequest): Promise<Types.GetV1EquipmentsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1EquipmentsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1EquipmentsGenerateExcel: Api['getV1EquipmentsGenerateExcel'] = async (request: Types.GetV1EquipmentsGenerateExcelRequest): Promise<Types.GetV1EquipmentsGenerateExcelResponses> => {
  return await _getV1EquipmentsGenerateExcel(baseUrl, request)
}
const _getV1EquipmentsFailuresGenerateExcel = async (url: string, request: Types.GetV1EquipmentsFailuresGenerateExcelRequest): Promise<Types.GetV1EquipmentsFailuresGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1EquipmentsFailuresGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/equipments/failures/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1EquipmentsFailuresGenerateExcel: Api['getV1EquipmentsFailuresGenerateExcel'] = async (request: Types.GetV1EquipmentsFailuresGenerateExcelRequest): Promise<Types.GetV1EquipmentsFailuresGenerateExcelResponses> => {
  return await _getV1EquipmentsFailuresGenerateExcel(baseUrl, request)
}
const _getV1FileUpload = async (url: string, request: Types.GetV1FileUploadRequest): Promise<Types.GetV1FileUploadResponses> => {
  const queryParameters: (keyof Types.GetV1FileUploadRequest)[]  = ['key', 'mimeType', 'partCount']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['file-size'] !== undefined) {
    headers['file-size'] = request['file-size']
    delete request['file-size']
  }

  const response = await fetch(`${url}/v1/file-upload/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1FileUpload: Api['getV1FileUpload'] = async (request: Types.GetV1FileUploadRequest): Promise<Types.GetV1FileUploadResponses> => {
  return await _getV1FileUpload(baseUrl, request)
}
const _postV1FileUploadMarkComplete = async (url: string, request: Types.PostV1FileUploadMarkCompleteRequest): Promise<Types.PostV1FileUploadMarkCompleteResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/file-upload/mark-complete`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1FileUploadMarkComplete: Api['postV1FileUploadMarkComplete'] = async (request: Types.PostV1FileUploadMarkCompleteRequest): Promise<Types.PostV1FileUploadMarkCompleteResponses> => {
  return await _postV1FileUploadMarkComplete(baseUrl, request)
}
const _getV1WorkCentre = async (url: string, request: Types.GetV1WorkCentreRequest): Promise<Types.GetV1WorkCentreResponses> => {
  const queryParameters: (keyof Types.GetV1WorkCentreRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-centre/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkCentre: Api['getV1WorkCentre'] = async (request: Types.GetV1WorkCentreRequest): Promise<Types.GetV1WorkCentreResponses> => {
  return await _getV1WorkCentre(baseUrl, request)
}
const _postV1WorkCentre = async (url: string, request: Types.PostV1WorkCentreRequest): Promise<Types.PostV1WorkCentreResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-centre/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WorkCentre: Api['postV1WorkCentre'] = async (request: Types.PostV1WorkCentreRequest): Promise<Types.PostV1WorkCentreResponses> => {
  return await _postV1WorkCentre(baseUrl, request)
}
const _getV1WorkCentreId = async (url: string, request: Types.GetV1WorkCentreIdRequest): Promise<Types.GetV1WorkCentreIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-centre/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkCentreId: Api['getV1WorkCentreId'] = async (request: Types.GetV1WorkCentreIdRequest): Promise<Types.GetV1WorkCentreIdResponses> => {
  return await _getV1WorkCentreId(baseUrl, request)
}
const _putV1WorkCentreId = async (url: string, request: Types.PutV1WorkCentreIdRequest): Promise<Types.PutV1WorkCentreIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-centre/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1WorkCentreId: Api['putV1WorkCentreId'] = async (request: Types.PutV1WorkCentreIdRequest): Promise<Types.PutV1WorkCentreIdResponses> => {
  return await _putV1WorkCentreId(baseUrl, request)
}
const _deleteV1WorkCentreId = async (url: string, request: Types.DeleteV1WorkCentreIdRequest): Promise<Types.DeleteV1WorkCentreIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-centre/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1WorkCentreId: Api['deleteV1WorkCentreId'] = async (request: Types.DeleteV1WorkCentreIdRequest): Promise<Types.DeleteV1WorkCentreIdResponses> => {
  return await _deleteV1WorkCentreId(baseUrl, request)
}
const _patchV1WorkCentreCostingId = async (url: string, request: Types.PatchV1WorkCentreCostingIdRequest): Promise<Types.PatchV1WorkCentreCostingIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-centre/costing/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1WorkCentreCostingId: Api['patchV1WorkCentreCostingId'] = async (request: Types.PatchV1WorkCentreCostingIdRequest): Promise<Types.PatchV1WorkCentreCostingIdResponses> => {
  return await _patchV1WorkCentreCostingId(baseUrl, request)
}
const _deleteV1WorkCentreCostingId = async (url: string, request: Types.DeleteV1WorkCentreCostingIdRequest): Promise<Types.DeleteV1WorkCentreCostingIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-centre/costing/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1WorkCentreCostingId: Api['deleteV1WorkCentreCostingId'] = async (request: Types.DeleteV1WorkCentreCostingIdRequest): Promise<Types.DeleteV1WorkCentreCostingIdResponses> => {
  return await _deleteV1WorkCentreCostingId(baseUrl, request)
}
const _patchV1WorkCentreEquipmentId = async (url: string, request: Types.PatchV1WorkCentreEquipmentIdRequest): Promise<Types.PatchV1WorkCentreEquipmentIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-centre/equipment/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1WorkCentreEquipmentId: Api['patchV1WorkCentreEquipmentId'] = async (request: Types.PatchV1WorkCentreEquipmentIdRequest): Promise<Types.PatchV1WorkCentreEquipmentIdResponses> => {
  return await _patchV1WorkCentreEquipmentId(baseUrl, request)
}
const _deleteV1WorkCentreEquipmentId = async (url: string, request: Types.DeleteV1WorkCentreEquipmentIdRequest): Promise<Types.DeleteV1WorkCentreEquipmentIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-centre/equipment/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1WorkCentreEquipmentId: Api['deleteV1WorkCentreEquipmentId'] = async (request: Types.DeleteV1WorkCentreEquipmentIdRequest): Promise<Types.DeleteV1WorkCentreEquipmentIdResponses> => {
  return await _deleteV1WorkCentreEquipmentId(baseUrl, request)
}
const _postV1WorkCentreCosting = async (url: string, request: Types.PostV1WorkCentreCostingRequest): Promise<Types.PostV1WorkCentreCostingResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-centre/costing`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WorkCentreCosting: Api['postV1WorkCentreCosting'] = async (request: Types.PostV1WorkCentreCostingRequest): Promise<Types.PostV1WorkCentreCostingResponses> => {
  return await _postV1WorkCentreCosting(baseUrl, request)
}
const _postV1WorkCentreEquipment = async (url: string, request: Types.PostV1WorkCentreEquipmentRequest): Promise<Types.PostV1WorkCentreEquipmentResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-centre/equipment`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WorkCentreEquipment: Api['postV1WorkCentreEquipment'] = async (request: Types.PostV1WorkCentreEquipmentRequest): Promise<Types.PostV1WorkCentreEquipmentResponses> => {
  return await _postV1WorkCentreEquipment(baseUrl, request)
}
const _postV1WorkCentreSaveAsDraft = async (url: string, request: Types.PostV1WorkCentreSaveAsDraftRequest): Promise<Types.PostV1WorkCentreSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-centre/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WorkCentreSaveAsDraft: Api['postV1WorkCentreSaveAsDraft'] = async (request: Types.PostV1WorkCentreSaveAsDraftRequest): Promise<Types.PostV1WorkCentreSaveAsDraftResponses> => {
  return await _postV1WorkCentreSaveAsDraft(baseUrl, request)
}
const _postV1WorkCentreImport = async (url: string, request: Types.PostV1WorkCentreImportRequest): Promise<Types.PostV1WorkCentreImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-centre/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WorkCentreImport: Api['postV1WorkCentreImport'] = async (request: Types.PostV1WorkCentreImportRequest): Promise<Types.PostV1WorkCentreImportResponses> => {
  return await _postV1WorkCentreImport(baseUrl, request)
}
const _getV1WorkCentreGenerateExcel = async (url: string, request: Types.GetV1WorkCentreGenerateExcelRequest): Promise<Types.GetV1WorkCentreGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1WorkCentreGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-centre/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkCentreGenerateExcel: Api['getV1WorkCentreGenerateExcel'] = async (request: Types.GetV1WorkCentreGenerateExcelRequest): Promise<Types.GetV1WorkCentreGenerateExcelResponses> => {
  return await _getV1WorkCentreGenerateExcel(baseUrl, request)
}
const _getV1Operations = async (url: string, request: Types.GetV1OperationsRequest): Promise<Types.GetV1OperationsResponses> => {
  const queryParameters: (keyof Types.GetV1OperationsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/operations/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Operations: Api['getV1Operations'] = async (request: Types.GetV1OperationsRequest): Promise<Types.GetV1OperationsResponses> => {
  return await _getV1Operations(baseUrl, request)
}
const _postV1Operations = async (url: string, request: Types.PostV1OperationsRequest): Promise<Types.PostV1OperationsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/operations/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Operations: Api['postV1Operations'] = async (request: Types.PostV1OperationsRequest): Promise<Types.PostV1OperationsResponses> => {
  return await _postV1Operations(baseUrl, request)
}
const _getV1OperationsId = async (url: string, request: Types.GetV1OperationsIdRequest): Promise<Types.GetV1OperationsIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/operations/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OperationsId: Api['getV1OperationsId'] = async (request: Types.GetV1OperationsIdRequest): Promise<Types.GetV1OperationsIdResponses> => {
  return await _getV1OperationsId(baseUrl, request)
}
const _putV1OperationsId = async (url: string, request: Types.PutV1OperationsIdRequest): Promise<Types.PutV1OperationsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/operations/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1OperationsId: Api['putV1OperationsId'] = async (request: Types.PutV1OperationsIdRequest): Promise<Types.PutV1OperationsIdResponses> => {
  return await _putV1OperationsId(baseUrl, request)
}
const _deleteV1OperationsId = async (url: string, request: Types.DeleteV1OperationsIdRequest): Promise<Types.DeleteV1OperationsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/operations/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1OperationsId: Api['deleteV1OperationsId'] = async (request: Types.DeleteV1OperationsIdRequest): Promise<Types.DeleteV1OperationsIdResponses> => {
  return await _deleteV1OperationsId(baseUrl, request)
}
const _postV1OperationsSaveAsDraft = async (url: string, request: Types.PostV1OperationsSaveAsDraftRequest): Promise<Types.PostV1OperationsSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/operations/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1OperationsSaveAsDraft: Api['postV1OperationsSaveAsDraft'] = async (request: Types.PostV1OperationsSaveAsDraftRequest): Promise<Types.PostV1OperationsSaveAsDraftResponses> => {
  return await _postV1OperationsSaveAsDraft(baseUrl, request)
}
const _patchV1OperationsCostingId = async (url: string, request: Types.PatchV1OperationsCostingIdRequest): Promise<Types.PatchV1OperationsCostingIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/operations/costing/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1OperationsCostingId: Api['patchV1OperationsCostingId'] = async (request: Types.PatchV1OperationsCostingIdRequest): Promise<Types.PatchV1OperationsCostingIdResponses> => {
  return await _patchV1OperationsCostingId(baseUrl, request)
}
const _deleteV1OperationsCostingId = async (url: string, request: Types.DeleteV1OperationsCostingIdRequest): Promise<Types.DeleteV1OperationsCostingIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/operations/costing/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1OperationsCostingId: Api['deleteV1OperationsCostingId'] = async (request: Types.DeleteV1OperationsCostingIdRequest): Promise<Types.DeleteV1OperationsCostingIdResponses> => {
  return await _deleteV1OperationsCostingId(baseUrl, request)
}
const _patchV1OperationsInstructionId = async (url: string, request: Types.PatchV1OperationsInstructionIdRequest): Promise<Types.PatchV1OperationsInstructionIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/operations/instruction/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1OperationsInstructionId: Api['patchV1OperationsInstructionId'] = async (request: Types.PatchV1OperationsInstructionIdRequest): Promise<Types.PatchV1OperationsInstructionIdResponses> => {
  return await _patchV1OperationsInstructionId(baseUrl, request)
}
const _deleteV1OperationsInstructionId = async (url: string, request: Types.DeleteV1OperationsInstructionIdRequest): Promise<Types.DeleteV1OperationsInstructionIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/operations/instruction/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1OperationsInstructionId: Api['deleteV1OperationsInstructionId'] = async (request: Types.DeleteV1OperationsInstructionIdRequest): Promise<Types.DeleteV1OperationsInstructionIdResponses> => {
  return await _deleteV1OperationsInstructionId(baseUrl, request)
}
const _postV1OperationsCosting = async (url: string, request: Types.PostV1OperationsCostingRequest): Promise<Types.PostV1OperationsCostingResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/operations/costing`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1OperationsCosting: Api['postV1OperationsCosting'] = async (request: Types.PostV1OperationsCostingRequest): Promise<Types.PostV1OperationsCostingResponses> => {
  return await _postV1OperationsCosting(baseUrl, request)
}
const _postV1OperationsInstruction = async (url: string, request: Types.PostV1OperationsInstructionRequest): Promise<Types.PostV1OperationsInstructionResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/operations/instruction`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1OperationsInstruction: Api['postV1OperationsInstruction'] = async (request: Types.PostV1OperationsInstructionRequest): Promise<Types.PostV1OperationsInstructionResponses> => {
  return await _postV1OperationsInstruction(baseUrl, request)
}
const _postV1OperationsImport = async (url: string, request: Types.PostV1OperationsImportRequest): Promise<Types.PostV1OperationsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/operations/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1OperationsImport: Api['postV1OperationsImport'] = async (request: Types.PostV1OperationsImportRequest): Promise<Types.PostV1OperationsImportResponses> => {
  return await _postV1OperationsImport(baseUrl, request)
}
const _getV1OperationsGenerateExcel = async (url: string, request: Types.GetV1OperationsGenerateExcelRequest): Promise<Types.GetV1OperationsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1OperationsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/operations/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OperationsGenerateExcel: Api['getV1OperationsGenerateExcel'] = async (request: Types.GetV1OperationsGenerateExcelRequest): Promise<Types.GetV1OperationsGenerateExcelResponses> => {
  return await _getV1OperationsGenerateExcel(baseUrl, request)
}
const _getV1BillsOfMaterials = async (url: string, request: Types.GetV1BillsOfMaterialsRequest): Promise<Types.GetV1BillsOfMaterialsResponses> => {
  const queryParameters: (keyof Types.GetV1BillsOfMaterialsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bills-of-materials/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BillsOfMaterials: Api['getV1BillsOfMaterials'] = async (request: Types.GetV1BillsOfMaterialsRequest): Promise<Types.GetV1BillsOfMaterialsResponses> => {
  return await _getV1BillsOfMaterials(baseUrl, request)
}
const _postV1BillsOfMaterials = async (url: string, request: Types.PostV1BillsOfMaterialsRequest): Promise<Types.PostV1BillsOfMaterialsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bills-of-materials/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1BillsOfMaterials: Api['postV1BillsOfMaterials'] = async (request: Types.PostV1BillsOfMaterialsRequest): Promise<Types.PostV1BillsOfMaterialsResponses> => {
  return await _postV1BillsOfMaterials(baseUrl, request)
}
const _getV1BillsOfMaterialsListMaterials = async (url: string, request: Types.GetV1BillsOfMaterialsListMaterialsRequest): Promise<Types.GetV1BillsOfMaterialsListMaterialsResponses> => {
  const queryParameters: (keyof Types.GetV1BillsOfMaterialsListMaterialsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bills-of-materials/list-materials?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BillsOfMaterialsListMaterials: Api['getV1BillsOfMaterialsListMaterials'] = async (request: Types.GetV1BillsOfMaterialsListMaterialsRequest): Promise<Types.GetV1BillsOfMaterialsListMaterialsResponses> => {
  return await _getV1BillsOfMaterialsListMaterials(baseUrl, request)
}
const _getV1BillsOfMaterialsId = async (url: string, request: Types.GetV1BillsOfMaterialsIdRequest): Promise<Types.GetV1BillsOfMaterialsIdResponses> => {
  const queryParameters: (keyof Types.GetV1BillsOfMaterialsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bills-of-materials/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BillsOfMaterialsId: Api['getV1BillsOfMaterialsId'] = async (request: Types.GetV1BillsOfMaterialsIdRequest): Promise<Types.GetV1BillsOfMaterialsIdResponses> => {
  return await _getV1BillsOfMaterialsId(baseUrl, request)
}
const _putV1BillsOfMaterialsId = async (url: string, request: Types.PutV1BillsOfMaterialsIdRequest): Promise<Types.PutV1BillsOfMaterialsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bills-of-materials/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1BillsOfMaterialsId: Api['putV1BillsOfMaterialsId'] = async (request: Types.PutV1BillsOfMaterialsIdRequest): Promise<Types.PutV1BillsOfMaterialsIdResponses> => {
  return await _putV1BillsOfMaterialsId(baseUrl, request)
}
const _deleteV1BillsOfMaterialsId = async (url: string, request: Types.DeleteV1BillsOfMaterialsIdRequest): Promise<Types.DeleteV1BillsOfMaterialsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bills-of-materials/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1BillsOfMaterialsId: Api['deleteV1BillsOfMaterialsId'] = async (request: Types.DeleteV1BillsOfMaterialsIdRequest): Promise<Types.DeleteV1BillsOfMaterialsIdResponses> => {
  return await _deleteV1BillsOfMaterialsId(baseUrl, request)
}
const _postV1BillsOfMaterialsSaveAsDraft = async (url: string, request: Types.PostV1BillsOfMaterialsSaveAsDraftRequest): Promise<Types.PostV1BillsOfMaterialsSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bills-of-materials/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1BillsOfMaterialsSaveAsDraft: Api['postV1BillsOfMaterialsSaveAsDraft'] = async (request: Types.PostV1BillsOfMaterialsSaveAsDraftRequest): Promise<Types.PostV1BillsOfMaterialsSaveAsDraftResponses> => {
  return await _postV1BillsOfMaterialsSaveAsDraft(baseUrl, request)
}
const _postV1BillsOfMaterialsIdMaterial = async (url: string, request: Types.PostV1BillsOfMaterialsIdMaterialRequest): Promise<Types.PostV1BillsOfMaterialsIdMaterialResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bills-of-materials/${request['id']}/material`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1BillsOfMaterialsIdMaterial: Api['postV1BillsOfMaterialsIdMaterial'] = async (request: Types.PostV1BillsOfMaterialsIdMaterialRequest): Promise<Types.PostV1BillsOfMaterialsIdMaterialResponses> => {
  return await _postV1BillsOfMaterialsIdMaterial(baseUrl, request)
}
const _patchV1BillsOfMaterialsMaterialId = async (url: string, request: Types.PatchV1BillsOfMaterialsMaterialIdRequest): Promise<Types.PatchV1BillsOfMaterialsMaterialIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bills-of-materials/material/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1BillsOfMaterialsMaterialId: Api['patchV1BillsOfMaterialsMaterialId'] = async (request: Types.PatchV1BillsOfMaterialsMaterialIdRequest): Promise<Types.PatchV1BillsOfMaterialsMaterialIdResponses> => {
  return await _patchV1BillsOfMaterialsMaterialId(baseUrl, request)
}
const _deleteV1BillsOfMaterialsMaterialId = async (url: string, request: Types.DeleteV1BillsOfMaterialsMaterialIdRequest): Promise<Types.DeleteV1BillsOfMaterialsMaterialIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bills-of-materials/material/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1BillsOfMaterialsMaterialId: Api['deleteV1BillsOfMaterialsMaterialId'] = async (request: Types.DeleteV1BillsOfMaterialsMaterialIdRequest): Promise<Types.DeleteV1BillsOfMaterialsMaterialIdResponses> => {
  return await _deleteV1BillsOfMaterialsMaterialId(baseUrl, request)
}
const _patchV1BillsOfMaterialsUpdateDefaultBom = async (url: string, request: Types.PatchV1BillsOfMaterialsUpdateDefaultBomRequest): Promise<Types.PatchV1BillsOfMaterialsUpdateDefaultBomResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bills-of-materials/update-default-bom`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1BillsOfMaterialsUpdateDefaultBom: Api['patchV1BillsOfMaterialsUpdateDefaultBom'] = async (request: Types.PatchV1BillsOfMaterialsUpdateDefaultBomRequest): Promise<Types.PatchV1BillsOfMaterialsUpdateDefaultBomResponses> => {
  return await _patchV1BillsOfMaterialsUpdateDefaultBom(baseUrl, request)
}
const _postV1BillsOfMaterialsAddApprover = async (url: string, request: Types.PostV1BillsOfMaterialsAddApproverRequest): Promise<Types.PostV1BillsOfMaterialsAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bills-of-materials/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1BillsOfMaterialsAddApprover: Api['postV1BillsOfMaterialsAddApprover'] = async (request: Types.PostV1BillsOfMaterialsAddApproverRequest): Promise<Types.PostV1BillsOfMaterialsAddApproverResponses> => {
  return await _postV1BillsOfMaterialsAddApprover(baseUrl, request)
}
const _putV1BillsOfMaterialsApprovalStatusId = async (url: string, request: Types.PutV1BillsOfMaterialsApprovalStatusIdRequest): Promise<Types.PutV1BillsOfMaterialsApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bills-of-materials/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1BillsOfMaterialsApprovalStatusId: Api['putV1BillsOfMaterialsApprovalStatusId'] = async (request: Types.PutV1BillsOfMaterialsApprovalStatusIdRequest): Promise<Types.PutV1BillsOfMaterialsApprovalStatusIdResponses> => {
  return await _putV1BillsOfMaterialsApprovalStatusId(baseUrl, request)
}
const _postV1BillsOfMaterialsImport = async (url: string, request: Types.PostV1BillsOfMaterialsImportRequest): Promise<Types.PostV1BillsOfMaterialsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bills-of-materials/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1BillsOfMaterialsImport: Api['postV1BillsOfMaterialsImport'] = async (request: Types.PostV1BillsOfMaterialsImportRequest): Promise<Types.PostV1BillsOfMaterialsImportResponses> => {
  return await _postV1BillsOfMaterialsImport(baseUrl, request)
}
const _getV1BillsOfMaterialsGenerateExcel = async (url: string, request: Types.GetV1BillsOfMaterialsGenerateExcelRequest): Promise<Types.GetV1BillsOfMaterialsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1BillsOfMaterialsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/bills-of-materials/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BillsOfMaterialsGenerateExcel: Api['getV1BillsOfMaterialsGenerateExcel'] = async (request: Types.GetV1BillsOfMaterialsGenerateExcelRequest): Promise<Types.GetV1BillsOfMaterialsGenerateExcelResponses> => {
  return await _getV1BillsOfMaterialsGenerateExcel(baseUrl, request)
}
const _postV1BuildOrdersSaveDraft = async (url: string, request: Types.PostV1BuildOrdersSaveDraftRequest): Promise<Types.PostV1BuildOrdersSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/build-orders/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1BuildOrdersSaveDraft: Api['postV1BuildOrdersSaveDraft'] = async (request: Types.PostV1BuildOrdersSaveDraftRequest): Promise<Types.PostV1BuildOrdersSaveDraftResponses> => {
  return await _postV1BuildOrdersSaveDraft(baseUrl, request)
}
const _postV1BuildOrders = async (url: string, request: Types.PostV1BuildOrdersRequest): Promise<Types.PostV1BuildOrdersResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/build-orders/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1BuildOrders: Api['postV1BuildOrders'] = async (request: Types.PostV1BuildOrdersRequest): Promise<Types.PostV1BuildOrdersResponses> => {
  return await _postV1BuildOrders(baseUrl, request)
}
const _getV1BuildOrders = async (url: string, request: Types.GetV1BuildOrdersRequest): Promise<Types.GetV1BuildOrdersResponses> => {
  const queryParameters: (keyof Types.GetV1BuildOrdersRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/build-orders/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BuildOrders: Api['getV1BuildOrders'] = async (request: Types.GetV1BuildOrdersRequest): Promise<Types.GetV1BuildOrdersResponses> => {
  return await _getV1BuildOrders(baseUrl, request)
}
const _getV1BuildOrdersId = async (url: string, request: Types.GetV1BuildOrdersIdRequest): Promise<Types.GetV1BuildOrdersIdResponses> => {
  const queryParameters: (keyof Types.GetV1BuildOrdersIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/build-orders/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BuildOrdersId: Api['getV1BuildOrdersId'] = async (request: Types.GetV1BuildOrdersIdRequest): Promise<Types.GetV1BuildOrdersIdResponses> => {
  return await _getV1BuildOrdersId(baseUrl, request)
}
const _deleteV1BuildOrdersId = async (url: string, request: Types.DeleteV1BuildOrdersIdRequest): Promise<Types.DeleteV1BuildOrdersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/build-orders/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1BuildOrdersId: Api['deleteV1BuildOrdersId'] = async (request: Types.DeleteV1BuildOrdersIdRequest): Promise<Types.DeleteV1BuildOrdersIdResponses> => {
  return await _deleteV1BuildOrdersId(baseUrl, request)
}
const _putV1BuildOrdersId = async (url: string, request: Types.PutV1BuildOrdersIdRequest): Promise<Types.PutV1BuildOrdersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/build-orders/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1BuildOrdersId: Api['putV1BuildOrdersId'] = async (request: Types.PutV1BuildOrdersIdRequest): Promise<Types.PutV1BuildOrdersIdResponses> => {
  return await _putV1BuildOrdersId(baseUrl, request)
}
const _putV1BuildOrdersByproductId = async (url: string, request: Types.PutV1BuildOrdersByproductIdRequest): Promise<Types.PutV1BuildOrdersByproductIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/build-orders/byproduct/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1BuildOrdersByproductId: Api['putV1BuildOrdersByproductId'] = async (request: Types.PutV1BuildOrdersByproductIdRequest): Promise<Types.PutV1BuildOrdersByproductIdResponses> => {
  return await _putV1BuildOrdersByproductId(baseUrl, request)
}
const _deleteV1BuildOrdersByproductId = async (url: string, request: Types.DeleteV1BuildOrdersByproductIdRequest): Promise<Types.DeleteV1BuildOrdersByproductIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/build-orders/byproduct/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1BuildOrdersByproductId: Api['deleteV1BuildOrdersByproductId'] = async (request: Types.DeleteV1BuildOrdersByproductIdRequest): Promise<Types.DeleteV1BuildOrdersByproductIdResponses> => {
  return await _deleteV1BuildOrdersByproductId(baseUrl, request)
}
const _putV1BuildOrdersMaterialId = async (url: string, request: Types.PutV1BuildOrdersMaterialIdRequest): Promise<Types.PutV1BuildOrdersMaterialIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/build-orders/material/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1BuildOrdersMaterialId: Api['putV1BuildOrdersMaterialId'] = async (request: Types.PutV1BuildOrdersMaterialIdRequest): Promise<Types.PutV1BuildOrdersMaterialIdResponses> => {
  return await _putV1BuildOrdersMaterialId(baseUrl, request)
}
const _deleteV1BuildOrdersMaterialId = async (url: string, request: Types.DeleteV1BuildOrdersMaterialIdRequest): Promise<Types.DeleteV1BuildOrdersMaterialIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/build-orders/material/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1BuildOrdersMaterialId: Api['deleteV1BuildOrdersMaterialId'] = async (request: Types.DeleteV1BuildOrdersMaterialIdRequest): Promise<Types.DeleteV1BuildOrdersMaterialIdResponses> => {
  return await _deleteV1BuildOrdersMaterialId(baseUrl, request)
}
const _getV1BuildOrdersIdAccountingLedger = async (url: string, request: Types.GetV1BuildOrdersIdAccountingLedgerRequest): Promise<Types.GetV1BuildOrdersIdAccountingLedgerResponses> => {
  const queryParameters: (keyof Types.GetV1BuildOrdersIdAccountingLedgerRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/build-orders/${request['id']}/accounting-ledger?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BuildOrdersIdAccountingLedger: Api['getV1BuildOrdersIdAccountingLedger'] = async (request: Types.GetV1BuildOrdersIdAccountingLedgerRequest): Promise<Types.GetV1BuildOrdersIdAccountingLedgerResponses> => {
  return await _getV1BuildOrdersIdAccountingLedger(baseUrl, request)
}
const _postV1BuildOrdersIdMaterialTracking = async (url: string, request: Types.PostV1BuildOrdersIdMaterialTrackingRequest): Promise<Types.PostV1BuildOrdersIdMaterialTrackingResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/build-orders/${request['id']}/material-tracking`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1BuildOrdersIdMaterialTracking: Api['postV1BuildOrdersIdMaterialTracking'] = async (request: Types.PostV1BuildOrdersIdMaterialTrackingRequest): Promise<Types.PostV1BuildOrdersIdMaterialTrackingResponses> => {
  return await _postV1BuildOrdersIdMaterialTracking(baseUrl, request)
}
const _putV1BuildOrdersIdStatus = async (url: string, request: Types.PutV1BuildOrdersIdStatusRequest): Promise<Types.PutV1BuildOrdersIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/build-orders/${request['id']}/status`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1BuildOrdersIdStatus: Api['putV1BuildOrdersIdStatus'] = async (request: Types.PutV1BuildOrdersIdStatusRequest): Promise<Types.PutV1BuildOrdersIdStatusResponses> => {
  return await _putV1BuildOrdersIdStatus(baseUrl, request)
}
const _getV1BuildOrdersIdCostAnalysis = async (url: string, request: Types.GetV1BuildOrdersIdCostAnalysisRequest): Promise<Types.GetV1BuildOrdersIdCostAnalysisResponses> => {
  const queryParameters: (keyof Types.GetV1BuildOrdersIdCostAnalysisRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/build-orders/${request['id']}/cost-analysis?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BuildOrdersIdCostAnalysis: Api['getV1BuildOrdersIdCostAnalysis'] = async (request: Types.GetV1BuildOrdersIdCostAnalysisRequest): Promise<Types.GetV1BuildOrdersIdCostAnalysisResponses> => {
  return await _getV1BuildOrdersIdCostAnalysis(baseUrl, request)
}
const _getV1BuildOrdersGenerateExcel = async (url: string, request: Types.GetV1BuildOrdersGenerateExcelRequest): Promise<Types.GetV1BuildOrdersGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1BuildOrdersGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/build-orders/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BuildOrdersGenerateExcel: Api['getV1BuildOrdersGenerateExcel'] = async (request: Types.GetV1BuildOrdersGenerateExcelRequest): Promise<Types.GetV1BuildOrdersGenerateExcelResponses> => {
  return await _getV1BuildOrdersGenerateExcel(baseUrl, request)
}
const _getV1BuildOrdersIdDownloadslitlabel = async (url: string, request: Types.GetV1BuildOrdersIdDownloadslitlabelRequest): Promise<Types.GetV1BuildOrdersIdDownloadslitlabelResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/build-orders/${request['id']}/downloadslitlabel`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1BuildOrdersIdDownloadslitlabel: Api['getV1BuildOrdersIdDownloadslitlabel'] = async (request: Types.GetV1BuildOrdersIdDownloadslitlabelRequest): Promise<Types.GetV1BuildOrdersIdDownloadslitlabelResponses> => {
  return await _getV1BuildOrdersIdDownloadslitlabel(baseUrl, request)
}
const _postV1BuildOrdersIdDownloadbyproductslitlabel = async (url: string, request: Types.PostV1BuildOrdersIdDownloadbyproductslitlabelRequest): Promise<Types.PostV1BuildOrdersIdDownloadbyproductslitlabelResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/build-orders/${request['id']}/downloadbyproductslitlabel`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1BuildOrdersIdDownloadbyproductslitlabel: Api['postV1BuildOrdersIdDownloadbyproductslitlabel'] = async (request: Types.PostV1BuildOrdersIdDownloadbyproductslitlabelRequest): Promise<Types.PostV1BuildOrdersIdDownloadbyproductslitlabelResponses> => {
  return await _postV1BuildOrdersIdDownloadbyproductslitlabel(baseUrl, request)
}
const _getV1JobCards = async (url: string, request: Types.GetV1JobCardsRequest): Promise<Types.GetV1JobCardsResponses> => {
  const queryParameters: (keyof Types.GetV1JobCardsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-cards/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1JobCards: Api['getV1JobCards'] = async (request: Types.GetV1JobCardsRequest): Promise<Types.GetV1JobCardsResponses> => {
  return await _getV1JobCards(baseUrl, request)
}
const _postV1JobCards = async (url: string, request: Types.PostV1JobCardsRequest): Promise<Types.PostV1JobCardsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-cards/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1JobCards: Api['postV1JobCards'] = async (request: Types.PostV1JobCardsRequest): Promise<Types.PostV1JobCardsResponses> => {
  return await _postV1JobCards(baseUrl, request)
}
const _getV1JobCardsId = async (url: string, request: Types.GetV1JobCardsIdRequest): Promise<Types.GetV1JobCardsIdResponses> => {
  const queryParameters: (keyof Types.GetV1JobCardsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-cards/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1JobCardsId: Api['getV1JobCardsId'] = async (request: Types.GetV1JobCardsIdRequest): Promise<Types.GetV1JobCardsIdResponses> => {
  return await _getV1JobCardsId(baseUrl, request)
}
const _putV1JobCardsId = async (url: string, request: Types.PutV1JobCardsIdRequest): Promise<Types.PutV1JobCardsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-cards/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1JobCardsId: Api['putV1JobCardsId'] = async (request: Types.PutV1JobCardsIdRequest): Promise<Types.PutV1JobCardsIdResponses> => {
  return await _putV1JobCardsId(baseUrl, request)
}
const _deleteV1JobCardsId = async (url: string, request: Types.DeleteV1JobCardsIdRequest): Promise<Types.DeleteV1JobCardsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-cards/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1JobCardsId: Api['deleteV1JobCardsId'] = async (request: Types.DeleteV1JobCardsIdRequest): Promise<Types.DeleteV1JobCardsIdResponses> => {
  return await _deleteV1JobCardsId(baseUrl, request)
}
const _postV1JobCardsOperations = async (url: string, request: Types.PostV1JobCardsOperationsRequest): Promise<Types.PostV1JobCardsOperationsResponses> => {
  const queryParameters: (keyof Types.PostV1JobCardsOperationsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-cards/operations?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1JobCardsOperations: Api['postV1JobCardsOperations'] = async (request: Types.PostV1JobCardsOperationsRequest): Promise<Types.PostV1JobCardsOperationsResponses> => {
  return await _postV1JobCardsOperations(baseUrl, request)
}
const _postV1JobCardsOperationsBatchAction = async (url: string, request: Types.PostV1JobCardsOperationsBatchActionRequest): Promise<Types.PostV1JobCardsOperationsBatchActionResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-cards/operations/batch-action`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1JobCardsOperationsBatchAction: Api['postV1JobCardsOperationsBatchAction'] = async (request: Types.PostV1JobCardsOperationsBatchActionRequest): Promise<Types.PostV1JobCardsOperationsBatchActionResponses> => {
  return await _postV1JobCardsOperationsBatchAction(baseUrl, request)
}
const _postV1JobCardsOperationsBulkOperations = async (url: string, request: Types.PostV1JobCardsOperationsBulkOperationsRequest): Promise<Types.PostV1JobCardsOperationsBulkOperationsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-cards/operations/bulk-operations`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1JobCardsOperationsBulkOperations: Api['postV1JobCardsOperationsBulkOperations'] = async (request: Types.PostV1JobCardsOperationsBulkOperationsRequest): Promise<Types.PostV1JobCardsOperationsBulkOperationsResponses> => {
  return await _postV1JobCardsOperationsBulkOperations(baseUrl, request)
}
const _postV1JobCardsSaveAsDraft = async (url: string, request: Types.PostV1JobCardsSaveAsDraftRequest): Promise<Types.PostV1JobCardsSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-cards/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1JobCardsSaveAsDraft: Api['postV1JobCardsSaveAsDraft'] = async (request: Types.PostV1JobCardsSaveAsDraftRequest): Promise<Types.PostV1JobCardsSaveAsDraftResponses> => {
  return await _postV1JobCardsSaveAsDraft(baseUrl, request)
}
const _putV1JobCardsRoutingId = async (url: string, request: Types.PutV1JobCardsRoutingIdRequest): Promise<Types.PutV1JobCardsRoutingIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-cards/routing/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1JobCardsRoutingId: Api['putV1JobCardsRoutingId'] = async (request: Types.PutV1JobCardsRoutingIdRequest): Promise<Types.PutV1JobCardsRoutingIdResponses> => {
  return await _putV1JobCardsRoutingId(baseUrl, request)
}
const _patchV1JobCardsStatusId = async (url: string, request: Types.PatchV1JobCardsStatusIdRequest): Promise<Types.PatchV1JobCardsStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-cards/status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1JobCardsStatusId: Api['patchV1JobCardsStatusId'] = async (request: Types.PatchV1JobCardsStatusIdRequest): Promise<Types.PatchV1JobCardsStatusIdResponses> => {
  return await _patchV1JobCardsStatusId(baseUrl, request)
}
const _patchV1JobCardsRoutingStatusId = async (url: string, request: Types.PatchV1JobCardsRoutingStatusIdRequest): Promise<Types.PatchV1JobCardsRoutingStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-cards/routing-status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1JobCardsRoutingStatusId: Api['patchV1JobCardsRoutingStatusId'] = async (request: Types.PatchV1JobCardsRoutingStatusIdRequest): Promise<Types.PatchV1JobCardsRoutingStatusIdResponses> => {
  return await _patchV1JobCardsRoutingStatusId(baseUrl, request)
}
const _patchV1JobCardsRoutingEquipmentStatusId = async (url: string, request: Types.PatchV1JobCardsRoutingEquipmentStatusIdRequest): Promise<Types.PatchV1JobCardsRoutingEquipmentStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-cards/routing-equipment-status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1JobCardsRoutingEquipmentStatusId: Api['patchV1JobCardsRoutingEquipmentStatusId'] = async (request: Types.PatchV1JobCardsRoutingEquipmentStatusIdRequest): Promise<Types.PatchV1JobCardsRoutingEquipmentStatusIdResponses> => {
  return await _patchV1JobCardsRoutingEquipmentStatusId(baseUrl, request)
}
const _patchV1JobCardsRoutingBlockStatusId = async (url: string, request: Types.PatchV1JobCardsRoutingBlockStatusIdRequest): Promise<Types.PatchV1JobCardsRoutingBlockStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-cards/routing-block-status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1JobCardsRoutingBlockStatusId: Api['patchV1JobCardsRoutingBlockStatusId'] = async (request: Types.PatchV1JobCardsRoutingBlockStatusIdRequest): Promise<Types.PatchV1JobCardsRoutingBlockStatusIdResponses> => {
  return await _patchV1JobCardsRoutingBlockStatusId(baseUrl, request)
}
const _postV1JobCardsIdRecordCompletion = async (url: string, request: Types.PostV1JobCardsIdRecordCompletionRequest): Promise<Types.PostV1JobCardsIdRecordCompletionResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-cards/${request['id']}/record-completion`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1JobCardsIdRecordCompletion: Api['postV1JobCardsIdRecordCompletion'] = async (request: Types.PostV1JobCardsIdRecordCompletionRequest): Promise<Types.PostV1JobCardsIdRecordCompletionResponses> => {
  return await _postV1JobCardsIdRecordCompletion(baseUrl, request)
}
const _getV1JobCardsIdRecordCompletion = async (url: string, request: Types.GetV1JobCardsIdRecordCompletionRequest): Promise<Types.GetV1JobCardsIdRecordCompletionResponses> => {
  const queryParameters: (keyof Types.GetV1JobCardsIdRecordCompletionRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-cards/${request['id']}/record-completion?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1JobCardsIdRecordCompletion: Api['getV1JobCardsIdRecordCompletion'] = async (request: Types.GetV1JobCardsIdRecordCompletionRequest): Promise<Types.GetV1JobCardsIdRecordCompletionResponses> => {
  return await _getV1JobCardsIdRecordCompletion(baseUrl, request)
}
const _getV1JobCardsJobCardIdRecordCompletionSummaryId = async (url: string, request: Types.GetV1JobCardsJobCardIdRecordCompletionSummaryIdRequest): Promise<Types.GetV1JobCardsJobCardIdRecordCompletionSummaryIdResponses> => {
  const queryParameters: (keyof Types.GetV1JobCardsJobCardIdRecordCompletionSummaryIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-cards/${request['jobCardId']}/record-completion-summary/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1JobCardsJobCardIdRecordCompletionSummaryId: Api['getV1JobCardsJobCardIdRecordCompletionSummaryId'] = async (request: Types.GetV1JobCardsJobCardIdRecordCompletionSummaryIdRequest): Promise<Types.GetV1JobCardsJobCardIdRecordCompletionSummaryIdResponses> => {
  return await _getV1JobCardsJobCardIdRecordCompletionSummaryId(baseUrl, request)
}
const _getV1JobCardsIdDownload = async (url: string, request: Types.GetV1JobCardsIdDownloadRequest): Promise<Types.GetV1JobCardsIdDownloadResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-cards/${request['id']}/download`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1JobCardsIdDownload: Api['getV1JobCardsIdDownload'] = async (request: Types.GetV1JobCardsIdDownloadRequest): Promise<Types.GetV1JobCardsIdDownloadResponses> => {
  return await _getV1JobCardsIdDownload(baseUrl, request)
}
const _getV1JobCardsGenerateExcel = async (url: string, request: Types.GetV1JobCardsGenerateExcelRequest): Promise<Types.GetV1JobCardsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1JobCardsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-cards/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1JobCardsGenerateExcel: Api['getV1JobCardsGenerateExcel'] = async (request: Types.GetV1JobCardsGenerateExcelRequest): Promise<Types.GetV1JobCardsGenerateExcelResponses> => {
  return await _getV1JobCardsGenerateExcel(baseUrl, request)
}
const _getV1JobCardsOperationsGenerateExcel = async (url: string, request: Types.GetV1JobCardsOperationsGenerateExcelRequest): Promise<Types.GetV1JobCardsOperationsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1JobCardsOperationsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/job-cards/operations/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1JobCardsOperationsGenerateExcel: Api['getV1JobCardsOperationsGenerateExcel'] = async (request: Types.GetV1JobCardsOperationsGenerateExcelRequest): Promise<Types.GetV1JobCardsOperationsGenerateExcelResponses> => {
  return await _getV1JobCardsOperationsGenerateExcel(baseUrl, request)
}
const _getV1Routing = async (url: string, request: Types.GetV1RoutingRequest): Promise<Types.GetV1RoutingResponses> => {
  const queryParameters: (keyof Types.GetV1RoutingRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/routing/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Routing: Api['getV1Routing'] = async (request: Types.GetV1RoutingRequest): Promise<Types.GetV1RoutingResponses> => {
  return await _getV1Routing(baseUrl, request)
}
const _postV1Routing = async (url: string, request: Types.PostV1RoutingRequest): Promise<Types.PostV1RoutingResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/routing/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Routing: Api['postV1Routing'] = async (request: Types.PostV1RoutingRequest): Promise<Types.PostV1RoutingResponses> => {
  return await _postV1Routing(baseUrl, request)
}
const _getV1RoutingId = async (url: string, request: Types.GetV1RoutingIdRequest): Promise<Types.GetV1RoutingIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/routing/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RoutingId: Api['getV1RoutingId'] = async (request: Types.GetV1RoutingIdRequest): Promise<Types.GetV1RoutingIdResponses> => {
  return await _getV1RoutingId(baseUrl, request)
}
const _putV1RoutingId = async (url: string, request: Types.PutV1RoutingIdRequest): Promise<Types.PutV1RoutingIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/routing/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RoutingId: Api['putV1RoutingId'] = async (request: Types.PutV1RoutingIdRequest): Promise<Types.PutV1RoutingIdResponses> => {
  return await _putV1RoutingId(baseUrl, request)
}
const _deleteV1RoutingId = async (url: string, request: Types.DeleteV1RoutingIdRequest): Promise<Types.DeleteV1RoutingIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/routing/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RoutingId: Api['deleteV1RoutingId'] = async (request: Types.DeleteV1RoutingIdRequest): Promise<Types.DeleteV1RoutingIdResponses> => {
  return await _deleteV1RoutingId(baseUrl, request)
}
const _postV1RoutingSaveAsDraft = async (url: string, request: Types.PostV1RoutingSaveAsDraftRequest): Promise<Types.PostV1RoutingSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/routing/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RoutingSaveAsDraft: Api['postV1RoutingSaveAsDraft'] = async (request: Types.PostV1RoutingSaveAsDraftRequest): Promise<Types.PostV1RoutingSaveAsDraftResponses> => {
  return await _postV1RoutingSaveAsDraft(baseUrl, request)
}
const _patchV1RoutingOperationId = async (url: string, request: Types.PatchV1RoutingOperationIdRequest): Promise<Types.PatchV1RoutingOperationIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/routing/operation/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1RoutingOperationId: Api['patchV1RoutingOperationId'] = async (request: Types.PatchV1RoutingOperationIdRequest): Promise<Types.PatchV1RoutingOperationIdResponses> => {
  return await _patchV1RoutingOperationId(baseUrl, request)
}
const _deleteV1RoutingOperationId = async (url: string, request: Types.DeleteV1RoutingOperationIdRequest): Promise<Types.DeleteV1RoutingOperationIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/routing/operation/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RoutingOperationId: Api['deleteV1RoutingOperationId'] = async (request: Types.DeleteV1RoutingOperationIdRequest): Promise<Types.DeleteV1RoutingOperationIdResponses> => {
  return await _deleteV1RoutingOperationId(baseUrl, request)
}
const _postV1RoutingOperation = async (url: string, request: Types.PostV1RoutingOperationRequest): Promise<Types.PostV1RoutingOperationResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/routing/operation`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RoutingOperation: Api['postV1RoutingOperation'] = async (request: Types.PostV1RoutingOperationRequest): Promise<Types.PostV1RoutingOperationResponses> => {
  return await _postV1RoutingOperation(baseUrl, request)
}
const _postV1RoutingImport = async (url: string, request: Types.PostV1RoutingImportRequest): Promise<Types.PostV1RoutingImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/routing/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RoutingImport: Api['postV1RoutingImport'] = async (request: Types.PostV1RoutingImportRequest): Promise<Types.PostV1RoutingImportResponses> => {
  return await _postV1RoutingImport(baseUrl, request)
}
const _getV1RoutingGenerateExcel = async (url: string, request: Types.GetV1RoutingGenerateExcelRequest): Promise<Types.GetV1RoutingGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1RoutingGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/routing/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RoutingGenerateExcel: Api['getV1RoutingGenerateExcel'] = async (request: Types.GetV1RoutingGenerateExcelRequest): Promise<Types.GetV1RoutingGenerateExcelResponses> => {
  return await _getV1RoutingGenerateExcel(baseUrl, request)
}
const _getV1WorkOrder = async (url: string, request: Types.GetV1WorkOrderRequest): Promise<Types.GetV1WorkOrderResponses> => {
  const queryParameters: (keyof Types.GetV1WorkOrderRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkOrder: Api['getV1WorkOrder'] = async (request: Types.GetV1WorkOrderRequest): Promise<Types.GetV1WorkOrderResponses> => {
  return await _getV1WorkOrder(baseUrl, request)
}
const _postV1WorkOrder = async (url: string, request: Types.PostV1WorkOrderRequest): Promise<Types.PostV1WorkOrderResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WorkOrder: Api['postV1WorkOrder'] = async (request: Types.PostV1WorkOrderRequest): Promise<Types.PostV1WorkOrderResponses> => {
  return await _postV1WorkOrder(baseUrl, request)
}
const _getV1WorkOrderId = async (url: string, request: Types.GetV1WorkOrderIdRequest): Promise<Types.GetV1WorkOrderIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkOrderId: Api['getV1WorkOrderId'] = async (request: Types.GetV1WorkOrderIdRequest): Promise<Types.GetV1WorkOrderIdResponses> => {
  return await _getV1WorkOrderId(baseUrl, request)
}
const _putV1WorkOrderId = async (url: string, request: Types.PutV1WorkOrderIdRequest): Promise<Types.PutV1WorkOrderIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1WorkOrderId: Api['putV1WorkOrderId'] = async (request: Types.PutV1WorkOrderIdRequest): Promise<Types.PutV1WorkOrderIdResponses> => {
  return await _putV1WorkOrderId(baseUrl, request)
}
const _deleteV1WorkOrderId = async (url: string, request: Types.DeleteV1WorkOrderIdRequest): Promise<Types.DeleteV1WorkOrderIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1WorkOrderId: Api['deleteV1WorkOrderId'] = async (request: Types.DeleteV1WorkOrderIdRequest): Promise<Types.DeleteV1WorkOrderIdResponses> => {
  return await _deleteV1WorkOrderId(baseUrl, request)
}
const _getV1WorkOrderIdAccountingLedger = async (url: string, request: Types.GetV1WorkOrderIdAccountingLedgerRequest): Promise<Types.GetV1WorkOrderIdAccountingLedgerResponses> => {
  const queryParameters: (keyof Types.GetV1WorkOrderIdAccountingLedgerRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/${request['id']}/accounting-ledger?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkOrderIdAccountingLedger: Api['getV1WorkOrderIdAccountingLedger'] = async (request: Types.GetV1WorkOrderIdAccountingLedgerRequest): Promise<Types.GetV1WorkOrderIdAccountingLedgerResponses> => {
  return await _getV1WorkOrderIdAccountingLedger(baseUrl, request)
}
const _postV1WorkOrderIdMaterialTracking = async (url: string, request: Types.PostV1WorkOrderIdMaterialTrackingRequest): Promise<Types.PostV1WorkOrderIdMaterialTrackingResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/${request['id']}/material-tracking`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WorkOrderIdMaterialTracking: Api['postV1WorkOrderIdMaterialTracking'] = async (request: Types.PostV1WorkOrderIdMaterialTrackingRequest): Promise<Types.PostV1WorkOrderIdMaterialTrackingResponses> => {
  return await _postV1WorkOrderIdMaterialTracking(baseUrl, request)
}
const _postV1WorkOrderSlit = async (url: string, request: Types.PostV1WorkOrderSlitRequest): Promise<Types.PostV1WorkOrderSlitResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/slit`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WorkOrderSlit: Api['postV1WorkOrderSlit'] = async (request: Types.PostV1WorkOrderSlitRequest): Promise<Types.PostV1WorkOrderSlitResponses> => {
  return await _postV1WorkOrderSlit(baseUrl, request)
}
const _postV1WorkOrderScaffolding = async (url: string, request: Types.PostV1WorkOrderScaffoldingRequest): Promise<Types.PostV1WorkOrderScaffoldingResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/scaffolding`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WorkOrderScaffolding: Api['postV1WorkOrderScaffolding'] = async (request: Types.PostV1WorkOrderScaffoldingRequest): Promise<Types.PostV1WorkOrderScaffoldingResponses> => {
  return await _postV1WorkOrderScaffolding(baseUrl, request)
}
const _putV1WorkOrderByproductId = async (url: string, request: Types.PutV1WorkOrderByproductIdRequest): Promise<Types.PutV1WorkOrderByproductIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/byproduct/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1WorkOrderByproductId: Api['putV1WorkOrderByproductId'] = async (request: Types.PutV1WorkOrderByproductIdRequest): Promise<Types.PutV1WorkOrderByproductIdResponses> => {
  return await _putV1WorkOrderByproductId(baseUrl, request)
}
const _deleteV1WorkOrderByproductId = async (url: string, request: Types.DeleteV1WorkOrderByproductIdRequest): Promise<Types.DeleteV1WorkOrderByproductIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/byproduct/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1WorkOrderByproductId: Api['deleteV1WorkOrderByproductId'] = async (request: Types.DeleteV1WorkOrderByproductIdRequest): Promise<Types.DeleteV1WorkOrderByproductIdResponses> => {
  return await _deleteV1WorkOrderByproductId(baseUrl, request)
}
const _postV1WorkOrderIdValidate = async (url: string, request: Types.PostV1WorkOrderIdValidateRequest): Promise<Types.PostV1WorkOrderIdValidateResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/${request['id']}/validate`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WorkOrderIdValidate: Api['postV1WorkOrderIdValidate'] = async (request: Types.PostV1WorkOrderIdValidateRequest): Promise<Types.PostV1WorkOrderIdValidateResponses> => {
  return await _postV1WorkOrderIdValidate(baseUrl, request)
}
const _getV1WorkOrderIdMaterialIssued = async (url: string, request: Types.GetV1WorkOrderIdMaterialIssuedRequest): Promise<Types.GetV1WorkOrderIdMaterialIssuedResponses> => {
  const queryParameters: (keyof Types.GetV1WorkOrderIdMaterialIssuedRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/${request['id']}/material-issued?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkOrderIdMaterialIssued: Api['getV1WorkOrderIdMaterialIssued'] = async (request: Types.GetV1WorkOrderIdMaterialIssuedRequest): Promise<Types.GetV1WorkOrderIdMaterialIssuedResponses> => {
  return await _getV1WorkOrderIdMaterialIssued(baseUrl, request)
}
const _getV1WorkOrderIdMaterialIssuedIssueIdDownload = async (url: string, request: Types.GetV1WorkOrderIdMaterialIssuedIssueIdDownloadRequest): Promise<Types.GetV1WorkOrderIdMaterialIssuedIssueIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1WorkOrderIdMaterialIssuedIssueIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/${request['id']}/material-issued/${request['issueId']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkOrderIdMaterialIssuedIssueIdDownload: Api['getV1WorkOrderIdMaterialIssuedIssueIdDownload'] = async (request: Types.GetV1WorkOrderIdMaterialIssuedIssueIdDownloadRequest): Promise<Types.GetV1WorkOrderIdMaterialIssuedIssueIdDownloadResponses> => {
  return await _getV1WorkOrderIdMaterialIssuedIssueIdDownload(baseUrl, request)
}
const _postV1WorkOrderMaterial = async (url: string, request: Types.PostV1WorkOrderMaterialRequest): Promise<Types.PostV1WorkOrderMaterialResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/material`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WorkOrderMaterial: Api['postV1WorkOrderMaterial'] = async (request: Types.PostV1WorkOrderMaterialRequest): Promise<Types.PostV1WorkOrderMaterialResponses> => {
  return await _postV1WorkOrderMaterial(baseUrl, request)
}
const _putV1WorkOrderMaterialId = async (url: string, request: Types.PutV1WorkOrderMaterialIdRequest): Promise<Types.PutV1WorkOrderMaterialIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/material/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1WorkOrderMaterialId: Api['putV1WorkOrderMaterialId'] = async (request: Types.PutV1WorkOrderMaterialIdRequest): Promise<Types.PutV1WorkOrderMaterialIdResponses> => {
  return await _putV1WorkOrderMaterialId(baseUrl, request)
}
const _deleteV1WorkOrderMaterialId = async (url: string, request: Types.DeleteV1WorkOrderMaterialIdRequest): Promise<Types.DeleteV1WorkOrderMaterialIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/material/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1WorkOrderMaterialId: Api['deleteV1WorkOrderMaterialId'] = async (request: Types.DeleteV1WorkOrderMaterialIdRequest): Promise<Types.DeleteV1WorkOrderMaterialIdResponses> => {
  return await _deleteV1WorkOrderMaterialId(baseUrl, request)
}
const _postV1WorkOrderSaveAsDraft = async (url: string, request: Types.PostV1WorkOrderSaveAsDraftRequest): Promise<Types.PostV1WorkOrderSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WorkOrderSaveAsDraft: Api['postV1WorkOrderSaveAsDraft'] = async (request: Types.PostV1WorkOrderSaveAsDraftRequest): Promise<Types.PostV1WorkOrderSaveAsDraftResponses> => {
  return await _postV1WorkOrderSaveAsDraft(baseUrl, request)
}
const _patchV1WorkOrderIdStatus = async (url: string, request: Types.PatchV1WorkOrderIdStatusRequest): Promise<Types.PatchV1WorkOrderIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1WorkOrderIdStatus: Api['patchV1WorkOrderIdStatus'] = async (request: Types.PatchV1WorkOrderIdStatusRequest): Promise<Types.PatchV1WorkOrderIdStatusResponses> => {
  return await _patchV1WorkOrderIdStatus(baseUrl, request)
}
const _getV1WorkOrderIdCostAnalysis = async (url: string, request: Types.GetV1WorkOrderIdCostAnalysisRequest): Promise<Types.GetV1WorkOrderIdCostAnalysisResponses> => {
  const queryParameters: (keyof Types.GetV1WorkOrderIdCostAnalysisRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/${request['id']}/cost-analysis?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkOrderIdCostAnalysis: Api['getV1WorkOrderIdCostAnalysis'] = async (request: Types.GetV1WorkOrderIdCostAnalysisRequest): Promise<Types.GetV1WorkOrderIdCostAnalysisResponses> => {
  return await _getV1WorkOrderIdCostAnalysis(baseUrl, request)
}
const _postV1WorkOrderImport = async (url: string, request: Types.PostV1WorkOrderImportRequest): Promise<Types.PostV1WorkOrderImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WorkOrderImport: Api['postV1WorkOrderImport'] = async (request: Types.PostV1WorkOrderImportRequest): Promise<Types.PostV1WorkOrderImportResponses> => {
  return await _postV1WorkOrderImport(baseUrl, request)
}
const _getV1WorkOrderIdScrap = async (url: string, request: Types.GetV1WorkOrderIdScrapRequest): Promise<Types.GetV1WorkOrderIdScrapResponses> => {
  const queryParameters: (keyof Types.GetV1WorkOrderIdScrapRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/${request['id']}/scrap?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkOrderIdScrap: Api['getV1WorkOrderIdScrap'] = async (request: Types.GetV1WorkOrderIdScrapRequest): Promise<Types.GetV1WorkOrderIdScrapResponses> => {
  return await _getV1WorkOrderIdScrap(baseUrl, request)
}
const _getV1WorkOrderIdDownload = async (url: string, request: Types.GetV1WorkOrderIdDownloadRequest): Promise<Types.GetV1WorkOrderIdDownloadResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/${request['id']}/download`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkOrderIdDownload: Api['getV1WorkOrderIdDownload'] = async (request: Types.GetV1WorkOrderIdDownloadRequest): Promise<Types.GetV1WorkOrderIdDownloadResponses> => {
  return await _getV1WorkOrderIdDownload(baseUrl, request)
}
const _getV1WorkOrderGenerateExcel = async (url: string, request: Types.GetV1WorkOrderGenerateExcelRequest): Promise<Types.GetV1WorkOrderGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1WorkOrderGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkOrderGenerateExcel: Api['getV1WorkOrderGenerateExcel'] = async (request: Types.GetV1WorkOrderGenerateExcelRequest): Promise<Types.GetV1WorkOrderGenerateExcelResponses> => {
  return await _getV1WorkOrderGenerateExcel(baseUrl, request)
}
const _postV1WorkOrderDemandPlanningSaveAsDraft = async (url: string, request: Types.PostV1WorkOrderDemandPlanningSaveAsDraftRequest): Promise<Types.PostV1WorkOrderDemandPlanningSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/work-order/demand-planning/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WorkOrderDemandPlanningSaveAsDraft: Api['postV1WorkOrderDemandPlanningSaveAsDraft'] = async (request: Types.PostV1WorkOrderDemandPlanningSaveAsDraftRequest): Promise<Types.PostV1WorkOrderDemandPlanningSaveAsDraftResponses> => {
  return await _postV1WorkOrderDemandPlanningSaveAsDraft(baseUrl, request)
}
const _postV1UnbuildOrdersSaveDraft = async (url: string, request: Types.PostV1UnbuildOrdersSaveDraftRequest): Promise<Types.PostV1UnbuildOrdersSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/unbuild-orders/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1UnbuildOrdersSaveDraft: Api['postV1UnbuildOrdersSaveDraft'] = async (request: Types.PostV1UnbuildOrdersSaveDraftRequest): Promise<Types.PostV1UnbuildOrdersSaveDraftResponses> => {
  return await _postV1UnbuildOrdersSaveDraft(baseUrl, request)
}
const _postV1UnbuildOrders = async (url: string, request: Types.PostV1UnbuildOrdersRequest): Promise<Types.PostV1UnbuildOrdersResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/unbuild-orders/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1UnbuildOrders: Api['postV1UnbuildOrders'] = async (request: Types.PostV1UnbuildOrdersRequest): Promise<Types.PostV1UnbuildOrdersResponses> => {
  return await _postV1UnbuildOrders(baseUrl, request)
}
const _getV1UnbuildOrders = async (url: string, request: Types.GetV1UnbuildOrdersRequest): Promise<Types.GetV1UnbuildOrdersResponses> => {
  const queryParameters: (keyof Types.GetV1UnbuildOrdersRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/unbuild-orders/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1UnbuildOrders: Api['getV1UnbuildOrders'] = async (request: Types.GetV1UnbuildOrdersRequest): Promise<Types.GetV1UnbuildOrdersResponses> => {
  return await _getV1UnbuildOrders(baseUrl, request)
}
const _getV1UnbuildOrdersId = async (url: string, request: Types.GetV1UnbuildOrdersIdRequest): Promise<Types.GetV1UnbuildOrdersIdResponses> => {
  const queryParameters: (keyof Types.GetV1UnbuildOrdersIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/unbuild-orders/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1UnbuildOrdersId: Api['getV1UnbuildOrdersId'] = async (request: Types.GetV1UnbuildOrdersIdRequest): Promise<Types.GetV1UnbuildOrdersIdResponses> => {
  return await _getV1UnbuildOrdersId(baseUrl, request)
}
const _deleteV1UnbuildOrdersId = async (url: string, request: Types.DeleteV1UnbuildOrdersIdRequest): Promise<Types.DeleteV1UnbuildOrdersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/unbuild-orders/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1UnbuildOrdersId: Api['deleteV1UnbuildOrdersId'] = async (request: Types.DeleteV1UnbuildOrdersIdRequest): Promise<Types.DeleteV1UnbuildOrdersIdResponses> => {
  return await _deleteV1UnbuildOrdersId(baseUrl, request)
}
const _putV1UnbuildOrdersId = async (url: string, request: Types.PutV1UnbuildOrdersIdRequest): Promise<Types.PutV1UnbuildOrdersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/unbuild-orders/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1UnbuildOrdersId: Api['putV1UnbuildOrdersId'] = async (request: Types.PutV1UnbuildOrdersIdRequest): Promise<Types.PutV1UnbuildOrdersIdResponses> => {
  return await _putV1UnbuildOrdersId(baseUrl, request)
}
const _getV1UnbuildOrdersIdAccountingLedger = async (url: string, request: Types.GetV1UnbuildOrdersIdAccountingLedgerRequest): Promise<Types.GetV1UnbuildOrdersIdAccountingLedgerResponses> => {
  const queryParameters: (keyof Types.GetV1UnbuildOrdersIdAccountingLedgerRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/unbuild-orders/${request['id']}/accounting-ledger?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1UnbuildOrdersIdAccountingLedger: Api['getV1UnbuildOrdersIdAccountingLedger'] = async (request: Types.GetV1UnbuildOrdersIdAccountingLedgerRequest): Promise<Types.GetV1UnbuildOrdersIdAccountingLedgerResponses> => {
  return await _getV1UnbuildOrdersIdAccountingLedger(baseUrl, request)
}
const _postV1UnbuildOrdersIdMaterial = async (url: string, request: Types.PostV1UnbuildOrdersIdMaterialRequest): Promise<Types.PostV1UnbuildOrdersIdMaterialResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/unbuild-orders/${request['id']}/material`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1UnbuildOrdersIdMaterial: Api['postV1UnbuildOrdersIdMaterial'] = async (request: Types.PostV1UnbuildOrdersIdMaterialRequest): Promise<Types.PostV1UnbuildOrdersIdMaterialResponses> => {
  return await _postV1UnbuildOrdersIdMaterial(baseUrl, request)
}
const _putV1UnbuildOrdersMaterialId = async (url: string, request: Types.PutV1UnbuildOrdersMaterialIdRequest): Promise<Types.PutV1UnbuildOrdersMaterialIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/unbuild-orders/material/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1UnbuildOrdersMaterialId: Api['putV1UnbuildOrdersMaterialId'] = async (request: Types.PutV1UnbuildOrdersMaterialIdRequest): Promise<Types.PutV1UnbuildOrdersMaterialIdResponses> => {
  return await _putV1UnbuildOrdersMaterialId(baseUrl, request)
}
const _deleteV1UnbuildOrdersMaterialId = async (url: string, request: Types.DeleteV1UnbuildOrdersMaterialIdRequest): Promise<Types.DeleteV1UnbuildOrdersMaterialIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/unbuild-orders/material/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1UnbuildOrdersMaterialId: Api['deleteV1UnbuildOrdersMaterialId'] = async (request: Types.DeleteV1UnbuildOrdersMaterialIdRequest): Promise<Types.DeleteV1UnbuildOrdersMaterialIdResponses> => {
  return await _deleteV1UnbuildOrdersMaterialId(baseUrl, request)
}
const _postV1UnbuildOrdersIdMaterialTracking = async (url: string, request: Types.PostV1UnbuildOrdersIdMaterialTrackingRequest): Promise<Types.PostV1UnbuildOrdersIdMaterialTrackingResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/unbuild-orders/${request['id']}/material-tracking`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1UnbuildOrdersIdMaterialTracking: Api['postV1UnbuildOrdersIdMaterialTracking'] = async (request: Types.PostV1UnbuildOrdersIdMaterialTrackingRequest): Promise<Types.PostV1UnbuildOrdersIdMaterialTrackingResponses> => {
  return await _postV1UnbuildOrdersIdMaterialTracking(baseUrl, request)
}
const _putV1UnbuildOrdersIdStatus = async (url: string, request: Types.PutV1UnbuildOrdersIdStatusRequest): Promise<Types.PutV1UnbuildOrdersIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/unbuild-orders/${request['id']}/status`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1UnbuildOrdersIdStatus: Api['putV1UnbuildOrdersIdStatus'] = async (request: Types.PutV1UnbuildOrdersIdStatusRequest): Promise<Types.PutV1UnbuildOrdersIdStatusResponses> => {
  return await _putV1UnbuildOrdersIdStatus(baseUrl, request)
}
const _getV1UnbuildOrdersGenerateExcel = async (url: string, request: Types.GetV1UnbuildOrdersGenerateExcelRequest): Promise<Types.GetV1UnbuildOrdersGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1UnbuildOrdersGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/unbuild-orders/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1UnbuildOrdersGenerateExcel: Api['getV1UnbuildOrdersGenerateExcel'] = async (request: Types.GetV1UnbuildOrdersGenerateExcelRequest): Promise<Types.GetV1UnbuildOrdersGenerateExcelResponses> => {
  return await _getV1UnbuildOrdersGenerateExcel(baseUrl, request)
}
const _postV1OperationBlock = async (url: string, request: Types.PostV1OperationBlockRequest): Promise<Types.PostV1OperationBlockResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/operation-block/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1OperationBlock: Api['postV1OperationBlock'] = async (request: Types.PostV1OperationBlockRequest): Promise<Types.PostV1OperationBlockResponses> => {
  return await _postV1OperationBlock(baseUrl, request)
}
const _getV1OperationBlock = async (url: string, request: Types.GetV1OperationBlockRequest): Promise<Types.GetV1OperationBlockResponses> => {
  const queryParameters: (keyof Types.GetV1OperationBlockRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/operation-block/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OperationBlock: Api['getV1OperationBlock'] = async (request: Types.GetV1OperationBlockRequest): Promise<Types.GetV1OperationBlockResponses> => {
  return await _getV1OperationBlock(baseUrl, request)
}
const _getV1OperationBlockId = async (url: string, request: Types.GetV1OperationBlockIdRequest): Promise<Types.GetV1OperationBlockIdResponses> => {
  const queryParameters: (keyof Types.GetV1OperationBlockIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/operation-block/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OperationBlockId: Api['getV1OperationBlockId'] = async (request: Types.GetV1OperationBlockIdRequest): Promise<Types.GetV1OperationBlockIdResponses> => {
  return await _getV1OperationBlockId(baseUrl, request)
}
const _deleteV1OperationBlockId = async (url: string, request: Types.DeleteV1OperationBlockIdRequest): Promise<Types.DeleteV1OperationBlockIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/operation-block/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1OperationBlockId: Api['deleteV1OperationBlockId'] = async (request: Types.DeleteV1OperationBlockIdRequest): Promise<Types.DeleteV1OperationBlockIdResponses> => {
  return await _deleteV1OperationBlockId(baseUrl, request)
}
const _putV1OperationBlockId = async (url: string, request: Types.PutV1OperationBlockIdRequest): Promise<Types.PutV1OperationBlockIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/operation-block/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1OperationBlockId: Api['putV1OperationBlockId'] = async (request: Types.PutV1OperationBlockIdRequest): Promise<Types.PutV1OperationBlockIdResponses> => {
  return await _putV1OperationBlockId(baseUrl, request)
}
const _getV1OperationBlockGenerateExcel = async (url: string, request: Types.GetV1OperationBlockGenerateExcelRequest): Promise<Types.GetV1OperationBlockGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1OperationBlockGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/operation-block/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OperationBlockGenerateExcel: Api['getV1OperationBlockGenerateExcel'] = async (request: Types.GetV1OperationBlockGenerateExcelRequest): Promise<Types.GetV1OperationBlockGenerateExcelResponses> => {
  return await _getV1OperationBlockGenerateExcel(baseUrl, request)
}
const _getV1Settings = async (url: string, request: Types.GetV1SettingsRequest): Promise<Types.GetV1SettingsResponses> => {
  const queryParameters: (keyof Types.GetV1SettingsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/settings/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Settings: Api['getV1Settings'] = async (request: Types.GetV1SettingsRequest): Promise<Types.GetV1SettingsResponses> => {
  return await _getV1Settings(baseUrl, request)
}
const _postV1Settings = async (url: string, request: Types.PostV1SettingsRequest): Promise<Types.PostV1SettingsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/settings/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Settings: Api['postV1Settings'] = async (request: Types.PostV1SettingsRequest): Promise<Types.PostV1SettingsResponses> => {
  return await _postV1Settings(baseUrl, request)
}
const _postV1ReportsRecordCompletionReport = async (url: string, request: Types.PostV1ReportsRecordCompletionReportRequest): Promise<Types.PostV1ReportsRecordCompletionReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/record-completion-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsRecordCompletionReport: Api['postV1ReportsRecordCompletionReport'] = async (request: Types.PostV1ReportsRecordCompletionReportRequest): Promise<Types.PostV1ReportsRecordCompletionReportResponses> => {
  return await _postV1ReportsRecordCompletionReport(baseUrl, request)
}
const _postV1ReportsFactoryDailyConsumptionReport = async (url: string, request: Types.PostV1ReportsFactoryDailyConsumptionReportRequest): Promise<Types.PostV1ReportsFactoryDailyConsumptionReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/factory-daily-consumption-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsFactoryDailyConsumptionReport: Api['postV1ReportsFactoryDailyConsumptionReport'] = async (request: Types.PostV1ReportsFactoryDailyConsumptionReportRequest): Promise<Types.PostV1ReportsFactoryDailyConsumptionReportResponses> => {
  return await _postV1ReportsFactoryDailyConsumptionReport(baseUrl, request)
}
const _postV1ReportsScrapReport = async (url: string, request: Types.PostV1ReportsScrapReportRequest): Promise<Types.PostV1ReportsScrapReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/scrap-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsScrapReport: Api['postV1ReportsScrapReport'] = async (request: Types.PostV1ReportsScrapReportRequest): Promise<Types.PostV1ReportsScrapReportResponses> => {
  return await _postV1ReportsScrapReport(baseUrl, request)
}
const _postV1ReportsComponentUsageReport = async (url: string, request: Types.PostV1ReportsComponentUsageReportRequest): Promise<Types.PostV1ReportsComponentUsageReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/component-usage-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsComponentUsageReport: Api['postV1ReportsComponentUsageReport'] = async (request: Types.PostV1ReportsComponentUsageReportRequest): Promise<Types.PostV1ReportsComponentUsageReportResponses> => {
  return await _postV1ReportsComponentUsageReport(baseUrl, request)
}
const _postV1ReportsBomInquiryReport = async (url: string, request: Types.PostV1ReportsBomInquiryReportRequest): Promise<Types.PostV1ReportsBomInquiryReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/bom-inquiry-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsBomInquiryReport: Api['postV1ReportsBomInquiryReport'] = async (request: Types.PostV1ReportsBomInquiryReportRequest): Promise<Types.PostV1ReportsBomInquiryReportResponses> => {
  return await _postV1ReportsBomInquiryReport(baseUrl, request)
}
const _postV1ReportsDowntimeReport = async (url: string, request: Types.PostV1ReportsDowntimeReportRequest): Promise<Types.PostV1ReportsDowntimeReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/downtime-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsDowntimeReport: Api['postV1ReportsDowntimeReport'] = async (request: Types.PostV1ReportsDowntimeReportRequest): Promise<Types.PostV1ReportsDowntimeReportResponses> => {
  return await _postV1ReportsDowntimeReport(baseUrl, request)
}
const _postV1ReportsWorkOrderStatusReport = async (url: string, request: Types.PostV1ReportsWorkOrderStatusReportRequest): Promise<Types.PostV1ReportsWorkOrderStatusReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/work-order-status-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsWorkOrderStatusReport: Api['postV1ReportsWorkOrderStatusReport'] = async (request: Types.PostV1ReportsWorkOrderStatusReportRequest): Promise<Types.PostV1ReportsWorkOrderStatusReportResponses> => {
  return await _postV1ReportsWorkOrderStatusReport(baseUrl, request)
}
const _postV1ReportsCostRollupReport = async (url: string, request: Types.PostV1ReportsCostRollupReportRequest): Promise<Types.PostV1ReportsCostRollupReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/cost-rollup-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsCostRollupReport: Api['postV1ReportsCostRollupReport'] = async (request: Types.PostV1ReportsCostRollupReportRequest): Promise<Types.PostV1ReportsCostRollupReportResponses> => {
  return await _postV1ReportsCostRollupReport(baseUrl, request)
}
const _postV1ReportsRoutingSchedulerReport = async (url: string, request: Types.PostV1ReportsRoutingSchedulerReportRequest): Promise<Types.PostV1ReportsRoutingSchedulerReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/routing-scheduler-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsRoutingSchedulerReport: Api['postV1ReportsRoutingSchedulerReport'] = async (request: Types.PostV1ReportsRoutingSchedulerReportRequest): Promise<Types.PostV1ReportsRoutingSchedulerReportResponses> => {
  return await _postV1ReportsRoutingSchedulerReport(baseUrl, request)
}
const _postV1ReportsWorkCenterSchedulerReport = async (url: string, request: Types.PostV1ReportsWorkCenterSchedulerReportRequest): Promise<Types.PostV1ReportsWorkCenterSchedulerReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/work-center-scheduler-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsWorkCenterSchedulerReport: Api['postV1ReportsWorkCenterSchedulerReport'] = async (request: Types.PostV1ReportsWorkCenterSchedulerReportRequest): Promise<Types.PostV1ReportsWorkCenterSchedulerReportResponses> => {
  return await _postV1ReportsWorkCenterSchedulerReport(baseUrl, request)
}
const _getV1ProductionPlan = async (url: string, request: Types.GetV1ProductionPlanRequest): Promise<Types.GetV1ProductionPlanResponses> => {
  const queryParameters: (keyof Types.GetV1ProductionPlanRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/production-plan/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ProductionPlan: Api['getV1ProductionPlan'] = async (request: Types.GetV1ProductionPlanRequest): Promise<Types.GetV1ProductionPlanResponses> => {
  return await _getV1ProductionPlan(baseUrl, request)
}
const _postV1ProductionPlan = async (url: string, request: Types.PostV1ProductionPlanRequest): Promise<Types.PostV1ProductionPlanResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/production-plan/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ProductionPlan: Api['postV1ProductionPlan'] = async (request: Types.PostV1ProductionPlanRequest): Promise<Types.PostV1ProductionPlanResponses> => {
  return await _postV1ProductionPlan(baseUrl, request)
}
const _getV1ProductionPlanId = async (url: string, request: Types.GetV1ProductionPlanIdRequest): Promise<Types.GetV1ProductionPlanIdResponses> => {
  const queryParameters: (keyof Types.GetV1ProductionPlanIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/production-plan/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ProductionPlanId: Api['getV1ProductionPlanId'] = async (request: Types.GetV1ProductionPlanIdRequest): Promise<Types.GetV1ProductionPlanIdResponses> => {
  return await _getV1ProductionPlanId(baseUrl, request)
}
const _deleteV1ProductionPlanId = async (url: string, request: Types.DeleteV1ProductionPlanIdRequest): Promise<Types.DeleteV1ProductionPlanIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/production-plan/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1ProductionPlanId: Api['deleteV1ProductionPlanId'] = async (request: Types.DeleteV1ProductionPlanIdRequest): Promise<Types.DeleteV1ProductionPlanIdResponses> => {
  return await _deleteV1ProductionPlanId(baseUrl, request)
}
const _patchV1ProductionPlanIdProductionPlanItem = async (url: string, request: Types.PatchV1ProductionPlanIdProductionPlanItemRequest): Promise<Types.PatchV1ProductionPlanIdProductionPlanItemResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/production-plan/${request['id']}/production-plan-item`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1ProductionPlanIdProductionPlanItem: Api['patchV1ProductionPlanIdProductionPlanItem'] = async (request: Types.PatchV1ProductionPlanIdProductionPlanItemRequest): Promise<Types.PatchV1ProductionPlanIdProductionPlanItemResponses> => {
  return await _patchV1ProductionPlanIdProductionPlanItem(baseUrl, request)
}
const _postV1ProductionPlanCheckAvailability = async (url: string, request: Types.PostV1ProductionPlanCheckAvailabilityRequest): Promise<Types.PostV1ProductionPlanCheckAvailabilityResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/production-plan/check-availability`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ProductionPlanCheckAvailability: Api['postV1ProductionPlanCheckAvailability'] = async (request: Types.PostV1ProductionPlanCheckAvailabilityRequest): Promise<Types.PostV1ProductionPlanCheckAvailabilityResponses> => {
  return await _postV1ProductionPlanCheckAvailability(baseUrl, request)
}
const _postV1ProductionPlanFetchAvailability = async (url: string, request: Types.PostV1ProductionPlanFetchAvailabilityRequest): Promise<Types.PostV1ProductionPlanFetchAvailabilityResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/production-plan/fetch-availability`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ProductionPlanFetchAvailability: Api['postV1ProductionPlanFetchAvailability'] = async (request: Types.PostV1ProductionPlanFetchAvailabilityRequest): Promise<Types.PostV1ProductionPlanFetchAvailabilityResponses> => {
  return await _postV1ProductionPlanFetchAvailability(baseUrl, request)
}
const _postV1ProductionPlanTraceRawMatterial = async (url: string, request: Types.PostV1ProductionPlanTraceRawMatterialRequest): Promise<Types.PostV1ProductionPlanTraceRawMatterialResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/production-plan/trace-raw-matterial`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ProductionPlanTraceRawMatterial: Api['postV1ProductionPlanTraceRawMatterial'] = async (request: Types.PostV1ProductionPlanTraceRawMatterialRequest): Promise<Types.PostV1ProductionPlanTraceRawMatterialResponses> => {
  return await _postV1ProductionPlanTraceRawMatterial(baseUrl, request)
}
const _postV1SlitPlanProvideDetails = async (url: string, request: Types.PostV1SlitPlanProvideDetailsRequest): Promise<Types.PostV1SlitPlanProvideDetailsResponses> => {
  const queryParameters: (keyof Types.PostV1SlitPlanProvideDetailsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/slit-plan/provide-details?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SlitPlanProvideDetails: Api['postV1SlitPlanProvideDetails'] = async (request: Types.PostV1SlitPlanProvideDetailsRequest): Promise<Types.PostV1SlitPlanProvideDetailsResponses> => {
  return await _postV1SlitPlanProvideDetails(baseUrl, request)
}
const _getV1SlitPlanSummary = async (url: string, request: Types.GetV1SlitPlanSummaryRequest): Promise<Types.GetV1SlitPlanSummaryResponses> => {
  const queryParameters: (keyof Types.GetV1SlitPlanSummaryRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/slit-plan/summary?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SlitPlanSummary: Api['getV1SlitPlanSummary'] = async (request: Types.GetV1SlitPlanSummaryRequest): Promise<Types.GetV1SlitPlanSummaryResponses> => {
  return await _getV1SlitPlanSummary(baseUrl, request)
}
const _getV1SlitPlanId = async (url: string, request: Types.GetV1SlitPlanIdRequest): Promise<Types.GetV1SlitPlanIdResponses> => {
  const queryParameters: (keyof Types.GetV1SlitPlanIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/slit-plan/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SlitPlanId: Api['getV1SlitPlanId'] = async (request: Types.GetV1SlitPlanIdRequest): Promise<Types.GetV1SlitPlanIdResponses> => {
  return await _getV1SlitPlanId(baseUrl, request)
}
const _putV1SlitPlanId = async (url: string, request: Types.PutV1SlitPlanIdRequest): Promise<Types.PutV1SlitPlanIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/slit-plan/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1SlitPlanId: Api['putV1SlitPlanId'] = async (request: Types.PutV1SlitPlanIdRequest): Promise<Types.PutV1SlitPlanIdResponses> => {
  return await _putV1SlitPlanId(baseUrl, request)
}
const _deleteV1SlitPlanId = async (url: string, request: Types.DeleteV1SlitPlanIdRequest): Promise<Types.DeleteV1SlitPlanIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/slit-plan/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1SlitPlanId: Api['deleteV1SlitPlanId'] = async (request: Types.DeleteV1SlitPlanIdRequest): Promise<Types.DeleteV1SlitPlanIdResponses> => {
  return await _deleteV1SlitPlanId(baseUrl, request)
}
const _getV1SlitPlanIdMaterialTracking = async (url: string, request: Types.GetV1SlitPlanIdMaterialTrackingRequest): Promise<Types.GetV1SlitPlanIdMaterialTrackingResponses> => {
  const queryParameters: (keyof Types.GetV1SlitPlanIdMaterialTrackingRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/slit-plan/${request['id']}/material-tracking?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SlitPlanIdMaterialTracking: Api['getV1SlitPlanIdMaterialTracking'] = async (request: Types.GetV1SlitPlanIdMaterialTrackingRequest): Promise<Types.GetV1SlitPlanIdMaterialTrackingResponses> => {
  return await _getV1SlitPlanIdMaterialTracking(baseUrl, request)
}
const _postV1SlitPlanCreate = async (url: string, request: Types.PostV1SlitPlanCreateRequest): Promise<Types.PostV1SlitPlanCreateResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/slit-plan/create`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SlitPlanCreate: Api['postV1SlitPlanCreate'] = async (request: Types.PostV1SlitPlanCreateRequest): Promise<Types.PostV1SlitPlanCreateResponses> => {
  return await _postV1SlitPlanCreate(baseUrl, request)
}
const _postV1SlitPlanSaveAsDraft = async (url: string, request: Types.PostV1SlitPlanSaveAsDraftRequest): Promise<Types.PostV1SlitPlanSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/slit-plan/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SlitPlanSaveAsDraft: Api['postV1SlitPlanSaveAsDraft'] = async (request: Types.PostV1SlitPlanSaveAsDraftRequest): Promise<Types.PostV1SlitPlanSaveAsDraftResponses> => {
  return await _postV1SlitPlanSaveAsDraft(baseUrl, request)
}
const _postV1SlitPlanIdSlitItem = async (url: string, request: Types.PostV1SlitPlanIdSlitItemRequest): Promise<Types.PostV1SlitPlanIdSlitItemResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/slit-plan/${request['id']}/slit-item`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SlitPlanIdSlitItem: Api['postV1SlitPlanIdSlitItem'] = async (request: Types.PostV1SlitPlanIdSlitItemRequest): Promise<Types.PostV1SlitPlanIdSlitItemResponses> => {
  return await _postV1SlitPlanIdSlitItem(baseUrl, request)
}
const _patchV1SlitPlanSlitItemId = async (url: string, request: Types.PatchV1SlitPlanSlitItemIdRequest): Promise<Types.PatchV1SlitPlanSlitItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/slit-plan/slit-item/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1SlitPlanSlitItemId: Api['patchV1SlitPlanSlitItemId'] = async (request: Types.PatchV1SlitPlanSlitItemIdRequest): Promise<Types.PatchV1SlitPlanSlitItemIdResponses> => {
  return await _patchV1SlitPlanSlitItemId(baseUrl, request)
}
const _deleteV1SlitPlanSlitItemId = async (url: string, request: Types.DeleteV1SlitPlanSlitItemIdRequest): Promise<Types.DeleteV1SlitPlanSlitItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/slit-plan/slit-item/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1SlitPlanSlitItemId: Api['deleteV1SlitPlanSlitItemId'] = async (request: Types.DeleteV1SlitPlanSlitItemIdRequest): Promise<Types.DeleteV1SlitPlanSlitItemIdResponses> => {
  return await _deleteV1SlitPlanSlitItemId(baseUrl, request)
}
const _postV1SlitPlanGetRawMaterialByType = async (url: string, request: Types.PostV1SlitPlanGetRawMaterialByTypeRequest): Promise<Types.PostV1SlitPlanGetRawMaterialByTypeResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/slit-plan/get-raw-material-by-type`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SlitPlanGetRawMaterialByType: Api['postV1SlitPlanGetRawMaterialByType'] = async (request: Types.PostV1SlitPlanGetRawMaterialByTypeRequest): Promise<Types.PostV1SlitPlanGetRawMaterialByTypeResponses> => {
  return await _postV1SlitPlanGetRawMaterialByType(baseUrl, request)
}
const _getV1SlitPlanSlitAssemblyItemId = async (url: string, request: Types.GetV1SlitPlanSlitAssemblyItemIdRequest): Promise<Types.GetV1SlitPlanSlitAssemblyItemIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/slit-plan/slit-assembly-item/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SlitPlanSlitAssemblyItemId: Api['getV1SlitPlanSlitAssemblyItemId'] = async (request: Types.GetV1SlitPlanSlitAssemblyItemIdRequest): Promise<Types.GetV1SlitPlanSlitAssemblyItemIdResponses> => {
  return await _getV1SlitPlanSlitAssemblyItemId(baseUrl, request)
}
const _getV1SlitPlanIdDownload = async (url: string, request: Types.GetV1SlitPlanIdDownloadRequest): Promise<Types.GetV1SlitPlanIdDownloadResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/slit-plan/${request['id']}/download`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SlitPlanIdDownload: Api['getV1SlitPlanIdDownload'] = async (request: Types.GetV1SlitPlanIdDownloadRequest): Promise<Types.GetV1SlitPlanIdDownloadResponses> => {
  return await _getV1SlitPlanIdDownload(baseUrl, request)
}
const _postV1SlitPlanAddApprover = async (url: string, request: Types.PostV1SlitPlanAddApproverRequest): Promise<Types.PostV1SlitPlanAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/slit-plan/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SlitPlanAddApprover: Api['postV1SlitPlanAddApprover'] = async (request: Types.PostV1SlitPlanAddApproverRequest): Promise<Types.PostV1SlitPlanAddApproverResponses> => {
  return await _postV1SlitPlanAddApprover(baseUrl, request)
}
const _putV1SlitPlanApprovalStatusId = async (url: string, request: Types.PutV1SlitPlanApprovalStatusIdRequest): Promise<Types.PutV1SlitPlanApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/slit-plan/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1SlitPlanApprovalStatusId: Api['putV1SlitPlanApprovalStatusId'] = async (request: Types.PutV1SlitPlanApprovalStatusIdRequest): Promise<Types.PutV1SlitPlanApprovalStatusIdResponses> => {
  return await _putV1SlitPlanApprovalStatusId(baseUrl, request)
}
const _getV1ScaffoldingPlanSummary = async (url: string, request: Types.GetV1ScaffoldingPlanSummaryRequest): Promise<Types.GetV1ScaffoldingPlanSummaryResponses> => {
  const queryParameters: (keyof Types.GetV1ScaffoldingPlanSummaryRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/scaffolding-plan/summary?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ScaffoldingPlanSummary: Api['getV1ScaffoldingPlanSummary'] = async (request: Types.GetV1ScaffoldingPlanSummaryRequest): Promise<Types.GetV1ScaffoldingPlanSummaryResponses> => {
  return await _getV1ScaffoldingPlanSummary(baseUrl, request)
}
const _getV1ScaffoldingPlanId = async (url: string, request: Types.GetV1ScaffoldingPlanIdRequest): Promise<Types.GetV1ScaffoldingPlanIdResponses> => {
  const queryParameters: (keyof Types.GetV1ScaffoldingPlanIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/scaffolding-plan/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ScaffoldingPlanId: Api['getV1ScaffoldingPlanId'] = async (request: Types.GetV1ScaffoldingPlanIdRequest): Promise<Types.GetV1ScaffoldingPlanIdResponses> => {
  return await _getV1ScaffoldingPlanId(baseUrl, request)
}
const _putV1ScaffoldingPlanId = async (url: string, request: Types.PutV1ScaffoldingPlanIdRequest): Promise<Types.PutV1ScaffoldingPlanIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/scaffolding-plan/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1ScaffoldingPlanId: Api['putV1ScaffoldingPlanId'] = async (request: Types.PutV1ScaffoldingPlanIdRequest): Promise<Types.PutV1ScaffoldingPlanIdResponses> => {
  return await _putV1ScaffoldingPlanId(baseUrl, request)
}
const _deleteV1ScaffoldingPlanId = async (url: string, request: Types.DeleteV1ScaffoldingPlanIdRequest): Promise<Types.DeleteV1ScaffoldingPlanIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/scaffolding-plan/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1ScaffoldingPlanId: Api['deleteV1ScaffoldingPlanId'] = async (request: Types.DeleteV1ScaffoldingPlanIdRequest): Promise<Types.DeleteV1ScaffoldingPlanIdResponses> => {
  return await _deleteV1ScaffoldingPlanId(baseUrl, request)
}
const _getV1ScaffoldingPlanIdMaterialTracking = async (url: string, request: Types.GetV1ScaffoldingPlanIdMaterialTrackingRequest): Promise<Types.GetV1ScaffoldingPlanIdMaterialTrackingResponses> => {
  const queryParameters: (keyof Types.GetV1ScaffoldingPlanIdMaterialTrackingRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/scaffolding-plan/${request['id']}/material-tracking?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ScaffoldingPlanIdMaterialTracking: Api['getV1ScaffoldingPlanIdMaterialTracking'] = async (request: Types.GetV1ScaffoldingPlanIdMaterialTrackingRequest): Promise<Types.GetV1ScaffoldingPlanIdMaterialTrackingResponses> => {
  return await _getV1ScaffoldingPlanIdMaterialTracking(baseUrl, request)
}
const _postV1ScaffoldingPlanCreate = async (url: string, request: Types.PostV1ScaffoldingPlanCreateRequest): Promise<Types.PostV1ScaffoldingPlanCreateResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/scaffolding-plan/create`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ScaffoldingPlanCreate: Api['postV1ScaffoldingPlanCreate'] = async (request: Types.PostV1ScaffoldingPlanCreateRequest): Promise<Types.PostV1ScaffoldingPlanCreateResponses> => {
  return await _postV1ScaffoldingPlanCreate(baseUrl, request)
}
const _postV1ScaffoldingPlanSaveAsDraft = async (url: string, request: Types.PostV1ScaffoldingPlanSaveAsDraftRequest): Promise<Types.PostV1ScaffoldingPlanSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/scaffolding-plan/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ScaffoldingPlanSaveAsDraft: Api['postV1ScaffoldingPlanSaveAsDraft'] = async (request: Types.PostV1ScaffoldingPlanSaveAsDraftRequest): Promise<Types.PostV1ScaffoldingPlanSaveAsDraftResponses> => {
  return await _postV1ScaffoldingPlanSaveAsDraft(baseUrl, request)
}
const _postV1ScaffoldingPlanIdScaffoldingItem = async (url: string, request: Types.PostV1ScaffoldingPlanIdScaffoldingItemRequest): Promise<Types.PostV1ScaffoldingPlanIdScaffoldingItemResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/scaffolding-plan/${request['id']}/scaffolding-item`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ScaffoldingPlanIdScaffoldingItem: Api['postV1ScaffoldingPlanIdScaffoldingItem'] = async (request: Types.PostV1ScaffoldingPlanIdScaffoldingItemRequest): Promise<Types.PostV1ScaffoldingPlanIdScaffoldingItemResponses> => {
  return await _postV1ScaffoldingPlanIdScaffoldingItem(baseUrl, request)
}
const _patchV1ScaffoldingPlanScaffoldingItemId = async (url: string, request: Types.PatchV1ScaffoldingPlanScaffoldingItemIdRequest): Promise<Types.PatchV1ScaffoldingPlanScaffoldingItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/scaffolding-plan/scaffolding-item/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1ScaffoldingPlanScaffoldingItemId: Api['patchV1ScaffoldingPlanScaffoldingItemId'] = async (request: Types.PatchV1ScaffoldingPlanScaffoldingItemIdRequest): Promise<Types.PatchV1ScaffoldingPlanScaffoldingItemIdResponses> => {
  return await _patchV1ScaffoldingPlanScaffoldingItemId(baseUrl, request)
}
const _deleteV1ScaffoldingPlanScaffoldingItemId = async (url: string, request: Types.DeleteV1ScaffoldingPlanScaffoldingItemIdRequest): Promise<Types.DeleteV1ScaffoldingPlanScaffoldingItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/scaffolding-plan/scaffolding-item/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1ScaffoldingPlanScaffoldingItemId: Api['deleteV1ScaffoldingPlanScaffoldingItemId'] = async (request: Types.DeleteV1ScaffoldingPlanScaffoldingItemIdRequest): Promise<Types.DeleteV1ScaffoldingPlanScaffoldingItemIdResponses> => {
  return await _deleteV1ScaffoldingPlanScaffoldingItemId(baseUrl, request)
}
const _postV1ScaffoldingPlanGetRawMaterialByType = async (url: string, request: Types.PostV1ScaffoldingPlanGetRawMaterialByTypeRequest): Promise<Types.PostV1ScaffoldingPlanGetRawMaterialByTypeResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/scaffolding-plan/get-raw-material-by-type`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ScaffoldingPlanGetRawMaterialByType: Api['postV1ScaffoldingPlanGetRawMaterialByType'] = async (request: Types.PostV1ScaffoldingPlanGetRawMaterialByTypeRequest): Promise<Types.PostV1ScaffoldingPlanGetRawMaterialByTypeResponses> => {
  return await _postV1ScaffoldingPlanGetRawMaterialByType(baseUrl, request)
}
const _getV1ScaffoldingPlanIdDownload = async (url: string, request: Types.GetV1ScaffoldingPlanIdDownloadRequest): Promise<Types.GetV1ScaffoldingPlanIdDownloadResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/scaffolding-plan/${request['id']}/download`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ScaffoldingPlanIdDownload: Api['getV1ScaffoldingPlanIdDownload'] = async (request: Types.GetV1ScaffoldingPlanIdDownloadRequest): Promise<Types.GetV1ScaffoldingPlanIdDownloadResponses> => {
  return await _getV1ScaffoldingPlanIdDownload(baseUrl, request)
}
const _postV1ScaffoldingPlanAddApprover = async (url: string, request: Types.PostV1ScaffoldingPlanAddApproverRequest): Promise<Types.PostV1ScaffoldingPlanAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/scaffolding-plan/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ScaffoldingPlanAddApprover: Api['postV1ScaffoldingPlanAddApprover'] = async (request: Types.PostV1ScaffoldingPlanAddApproverRequest): Promise<Types.PostV1ScaffoldingPlanAddApproverResponses> => {
  return await _postV1ScaffoldingPlanAddApprover(baseUrl, request)
}
const _putV1ScaffoldingPlanApprovalStatusId = async (url: string, request: Types.PutV1ScaffoldingPlanApprovalStatusIdRequest): Promise<Types.PutV1ScaffoldingPlanApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/scaffolding-plan/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1ScaffoldingPlanApprovalStatusId: Api['putV1ScaffoldingPlanApprovalStatusId'] = async (request: Types.PutV1ScaffoldingPlanApprovalStatusIdRequest): Promise<Types.PutV1ScaffoldingPlanApprovalStatusIdResponses> => {
  return await _putV1ScaffoldingPlanApprovalStatusId(baseUrl, request)
}
const _getV1GateRegister = async (url: string, request: Types.GetV1GateRegisterRequest): Promise<Types.GetV1GateRegisterResponses> => {
  const queryParameters: (keyof Types.GetV1GateRegisterRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/gate-register/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1GateRegister: Api['getV1GateRegister'] = async (request: Types.GetV1GateRegisterRequest): Promise<Types.GetV1GateRegisterResponses> => {
  return await _getV1GateRegister(baseUrl, request)
}
const _postV1GateRegister = async (url: string, request: Types.PostV1GateRegisterRequest): Promise<Types.PostV1GateRegisterResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/gate-register/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1GateRegister: Api['postV1GateRegister'] = async (request: Types.PostV1GateRegisterRequest): Promise<Types.PostV1GateRegisterResponses> => {
  return await _postV1GateRegister(baseUrl, request)
}
const _getV1GateRegisterId = async (url: string, request: Types.GetV1GateRegisterIdRequest): Promise<Types.GetV1GateRegisterIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/gate-register/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1GateRegisterId: Api['getV1GateRegisterId'] = async (request: Types.GetV1GateRegisterIdRequest): Promise<Types.GetV1GateRegisterIdResponses> => {
  return await _getV1GateRegisterId(baseUrl, request)
}
const _putV1GateRegisterId = async (url: string, request: Types.PutV1GateRegisterIdRequest): Promise<Types.PutV1GateRegisterIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/gate-register/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1GateRegisterId: Api['putV1GateRegisterId'] = async (request: Types.PutV1GateRegisterIdRequest): Promise<Types.PutV1GateRegisterIdResponses> => {
  return await _putV1GateRegisterId(baseUrl, request)
}
const _deleteV1GateRegisterId = async (url: string, request: Types.DeleteV1GateRegisterIdRequest): Promise<Types.DeleteV1GateRegisterIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/gate-register/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1GateRegisterId: Api['deleteV1GateRegisterId'] = async (request: Types.DeleteV1GateRegisterIdRequest): Promise<Types.DeleteV1GateRegisterIdResponses> => {
  return await _deleteV1GateRegisterId(baseUrl, request)
}
const _getV1GateRegisterVehicleNumbers = async (url: string, request: Types.GetV1GateRegisterVehicleNumbersRequest): Promise<Types.GetV1GateRegisterVehicleNumbersResponses> => {
  const queryParameters: (keyof Types.GetV1GateRegisterVehicleNumbersRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/gate-register/vehicle-numbers?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1GateRegisterVehicleNumbers: Api['getV1GateRegisterVehicleNumbers'] = async (request: Types.GetV1GateRegisterVehicleNumbersRequest): Promise<Types.GetV1GateRegisterVehicleNumbersResponses> => {
  return await _getV1GateRegisterVehicleNumbers(baseUrl, request)
}
const _postV1GateRegisterVehicleNumbers = async (url: string, request: Types.PostV1GateRegisterVehicleNumbersRequest): Promise<Types.PostV1GateRegisterVehicleNumbersResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/gate-register/vehicle-numbers`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1GateRegisterVehicleNumbers: Api['postV1GateRegisterVehicleNumbers'] = async (request: Types.PostV1GateRegisterVehicleNumbersRequest): Promise<Types.PostV1GateRegisterVehicleNumbersResponses> => {
  return await _postV1GateRegisterVehicleNumbers(baseUrl, request)
}
const _getV1GateRegisterVehicleTypes = async (url: string, request: Types.GetV1GateRegisterVehicleTypesRequest): Promise<Types.GetV1GateRegisterVehicleTypesResponses> => {
  const queryParameters: (keyof Types.GetV1GateRegisterVehicleTypesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/gate-register/vehicle-types?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1GateRegisterVehicleTypes: Api['getV1GateRegisterVehicleTypes'] = async (request: Types.GetV1GateRegisterVehicleTypesRequest): Promise<Types.GetV1GateRegisterVehicleTypesResponses> => {
  return await _getV1GateRegisterVehicleTypes(baseUrl, request)
}
const _postV1GateRegisterVehicleTypes = async (url: string, request: Types.PostV1GateRegisterVehicleTypesRequest): Promise<Types.PostV1GateRegisterVehicleTypesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/gate-register/vehicle-types`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1GateRegisterVehicleTypes: Api['postV1GateRegisterVehicleTypes'] = async (request: Types.PostV1GateRegisterVehicleTypesRequest): Promise<Types.PostV1GateRegisterVehicleTypesResponses> => {
  return await _postV1GateRegisterVehicleTypes(baseUrl, request)
}
const _getV1GateRegisterGenerateExcel = async (url: string, request: Types.GetV1GateRegisterGenerateExcelRequest): Promise<Types.GetV1GateRegisterGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1GateRegisterGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/gate-register/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1GateRegisterGenerateExcel: Api['getV1GateRegisterGenerateExcel'] = async (request: Types.GetV1GateRegisterGenerateExcelRequest): Promise<Types.GetV1GateRegisterGenerateExcelResponses> => {
  return await _getV1GateRegisterGenerateExcel(baseUrl, request)
}
type BuildOptions = {
  headers?: Object
}
export default function build (url: string, options?: BuildOptions) {
  url = sanitizeUrl(url)
  if (options?.headers) {
    defaultHeaders = options.headers
  }
  return {
    getV1WorkCentreCategories: _getV1WorkCentreCategories.bind(url, ...arguments),
    postV1WorkCentreCategories: _postV1WorkCentreCategories.bind(url, ...arguments),
    getV1WorkCentreCategoriesId: _getV1WorkCentreCategoriesId.bind(url, ...arguments),
    putV1WorkCentreCategoriesId: _putV1WorkCentreCategoriesId.bind(url, ...arguments),
    deleteV1WorkCentreCategoriesId: _deleteV1WorkCentreCategoriesId.bind(url, ...arguments),
    postV1WorkCentreCategoriesSaveAsDraft: _postV1WorkCentreCategoriesSaveAsDraft.bind(url, ...arguments),
    postV1WorkCentreCategoriesImport: _postV1WorkCentreCategoriesImport.bind(url, ...arguments),
    getV1WorkCentreCategoriesGenerateExcel: _getV1WorkCentreCategoriesGenerateExcel.bind(url, ...arguments),
    getV1Equipments: _getV1Equipments.bind(url, ...arguments),
    postV1Equipments: _postV1Equipments.bind(url, ...arguments),
    getV1EquipmentsId: _getV1EquipmentsId.bind(url, ...arguments),
    putV1EquipmentsId: _putV1EquipmentsId.bind(url, ...arguments),
    deleteV1EquipmentsId: _deleteV1EquipmentsId.bind(url, ...arguments),
    postV1EquipmentsSaveAsDraft: _postV1EquipmentsSaveAsDraft.bind(url, ...arguments),
    getV1EquipmentsCategories: _getV1EquipmentsCategories.bind(url, ...arguments),
    getV1EquipmentsMaintenanceHistory: _getV1EquipmentsMaintenanceHistory.bind(url, ...arguments),
    postV1EquipmentsMaintenanceHistory: _postV1EquipmentsMaintenanceHistory.bind(url, ...arguments),
    getV1EquipmentsMaintenanceHistoryId: _getV1EquipmentsMaintenanceHistoryId.bind(url, ...arguments),
    putV1EquipmentsMaintenanceHistoryId: _putV1EquipmentsMaintenanceHistoryId.bind(url, ...arguments),
    deleteV1EquipmentsMaintenanceHistoryId: _deleteV1EquipmentsMaintenanceHistoryId.bind(url, ...arguments),
    patchV1EquipmentsElectricityConsumptionId: _patchV1EquipmentsElectricityConsumptionId.bind(url, ...arguments),
    deleteV1EquipmentsElectricityConsumptionId: _deleteV1EquipmentsElectricityConsumptionId.bind(url, ...arguments),
    postV1EquipmentsElectricityConsumption: _postV1EquipmentsElectricityConsumption.bind(url, ...arguments),
    patchV1EquipmentsVoltageInspectionId: _patchV1EquipmentsVoltageInspectionId.bind(url, ...arguments),
    deleteV1EquipmentsVoltageInspectionId: _deleteV1EquipmentsVoltageInspectionId.bind(url, ...arguments),
    postV1EquipmentsVoltageInspection: _postV1EquipmentsVoltageInspection.bind(url, ...arguments),
    getV1EquipmentsFailures: _getV1EquipmentsFailures.bind(url, ...arguments),
    postV1EquipmentsFailures: _postV1EquipmentsFailures.bind(url, ...arguments),
    getV1EquipmentsFailuresId: _getV1EquipmentsFailuresId.bind(url, ...arguments),
    putV1EquipmentsFailuresId: _putV1EquipmentsFailuresId.bind(url, ...arguments),
    deleteV1EquipmentsFailuresId: _deleteV1EquipmentsFailuresId.bind(url, ...arguments),
    postV1EquipmentsFailuresSaveAsDraft: _postV1EquipmentsFailuresSaveAsDraft.bind(url, ...arguments),
    patchV1EquipmentsFailuresUpdateStatusId: _patchV1EquipmentsFailuresUpdateStatusId.bind(url, ...arguments),
    postV1EquipmentsImport: _postV1EquipmentsImport.bind(url, ...arguments),
    getV1EquipmentsGenerateExcel: _getV1EquipmentsGenerateExcel.bind(url, ...arguments),
    getV1EquipmentsFailuresGenerateExcel: _getV1EquipmentsFailuresGenerateExcel.bind(url, ...arguments),
    getV1FileUpload: _getV1FileUpload.bind(url, ...arguments),
    postV1FileUploadMarkComplete: _postV1FileUploadMarkComplete.bind(url, ...arguments),
    getV1WorkCentre: _getV1WorkCentre.bind(url, ...arguments),
    postV1WorkCentre: _postV1WorkCentre.bind(url, ...arguments),
    getV1WorkCentreId: _getV1WorkCentreId.bind(url, ...arguments),
    putV1WorkCentreId: _putV1WorkCentreId.bind(url, ...arguments),
    deleteV1WorkCentreId: _deleteV1WorkCentreId.bind(url, ...arguments),
    patchV1WorkCentreCostingId: _patchV1WorkCentreCostingId.bind(url, ...arguments),
    deleteV1WorkCentreCostingId: _deleteV1WorkCentreCostingId.bind(url, ...arguments),
    patchV1WorkCentreEquipmentId: _patchV1WorkCentreEquipmentId.bind(url, ...arguments),
    deleteV1WorkCentreEquipmentId: _deleteV1WorkCentreEquipmentId.bind(url, ...arguments),
    postV1WorkCentreCosting: _postV1WorkCentreCosting.bind(url, ...arguments),
    postV1WorkCentreEquipment: _postV1WorkCentreEquipment.bind(url, ...arguments),
    postV1WorkCentreSaveAsDraft: _postV1WorkCentreSaveAsDraft.bind(url, ...arguments),
    postV1WorkCentreImport: _postV1WorkCentreImport.bind(url, ...arguments),
    getV1WorkCentreGenerateExcel: _getV1WorkCentreGenerateExcel.bind(url, ...arguments),
    getV1Operations: _getV1Operations.bind(url, ...arguments),
    postV1Operations: _postV1Operations.bind(url, ...arguments),
    getV1OperationsId: _getV1OperationsId.bind(url, ...arguments),
    putV1OperationsId: _putV1OperationsId.bind(url, ...arguments),
    deleteV1OperationsId: _deleteV1OperationsId.bind(url, ...arguments),
    postV1OperationsSaveAsDraft: _postV1OperationsSaveAsDraft.bind(url, ...arguments),
    patchV1OperationsCostingId: _patchV1OperationsCostingId.bind(url, ...arguments),
    deleteV1OperationsCostingId: _deleteV1OperationsCostingId.bind(url, ...arguments),
    patchV1OperationsInstructionId: _patchV1OperationsInstructionId.bind(url, ...arguments),
    deleteV1OperationsInstructionId: _deleteV1OperationsInstructionId.bind(url, ...arguments),
    postV1OperationsCosting: _postV1OperationsCosting.bind(url, ...arguments),
    postV1OperationsInstruction: _postV1OperationsInstruction.bind(url, ...arguments),
    postV1OperationsImport: _postV1OperationsImport.bind(url, ...arguments),
    getV1OperationsGenerateExcel: _getV1OperationsGenerateExcel.bind(url, ...arguments),
    getV1BillsOfMaterials: _getV1BillsOfMaterials.bind(url, ...arguments),
    postV1BillsOfMaterials: _postV1BillsOfMaterials.bind(url, ...arguments),
    getV1BillsOfMaterialsListMaterials: _getV1BillsOfMaterialsListMaterials.bind(url, ...arguments),
    getV1BillsOfMaterialsId: _getV1BillsOfMaterialsId.bind(url, ...arguments),
    putV1BillsOfMaterialsId: _putV1BillsOfMaterialsId.bind(url, ...arguments),
    deleteV1BillsOfMaterialsId: _deleteV1BillsOfMaterialsId.bind(url, ...arguments),
    postV1BillsOfMaterialsSaveAsDraft: _postV1BillsOfMaterialsSaveAsDraft.bind(url, ...arguments),
    postV1BillsOfMaterialsIdMaterial: _postV1BillsOfMaterialsIdMaterial.bind(url, ...arguments),
    patchV1BillsOfMaterialsMaterialId: _patchV1BillsOfMaterialsMaterialId.bind(url, ...arguments),
    deleteV1BillsOfMaterialsMaterialId: _deleteV1BillsOfMaterialsMaterialId.bind(url, ...arguments),
    patchV1BillsOfMaterialsUpdateDefaultBom: _patchV1BillsOfMaterialsUpdateDefaultBom.bind(url, ...arguments),
    postV1BillsOfMaterialsAddApprover: _postV1BillsOfMaterialsAddApprover.bind(url, ...arguments),
    putV1BillsOfMaterialsApprovalStatusId: _putV1BillsOfMaterialsApprovalStatusId.bind(url, ...arguments),
    postV1BillsOfMaterialsImport: _postV1BillsOfMaterialsImport.bind(url, ...arguments),
    getV1BillsOfMaterialsGenerateExcel: _getV1BillsOfMaterialsGenerateExcel.bind(url, ...arguments),
    postV1BuildOrdersSaveDraft: _postV1BuildOrdersSaveDraft.bind(url, ...arguments),
    postV1BuildOrders: _postV1BuildOrders.bind(url, ...arguments),
    getV1BuildOrders: _getV1BuildOrders.bind(url, ...arguments),
    getV1BuildOrdersId: _getV1BuildOrdersId.bind(url, ...arguments),
    deleteV1BuildOrdersId: _deleteV1BuildOrdersId.bind(url, ...arguments),
    putV1BuildOrdersId: _putV1BuildOrdersId.bind(url, ...arguments),
    putV1BuildOrdersByproductId: _putV1BuildOrdersByproductId.bind(url, ...arguments),
    deleteV1BuildOrdersByproductId: _deleteV1BuildOrdersByproductId.bind(url, ...arguments),
    putV1BuildOrdersMaterialId: _putV1BuildOrdersMaterialId.bind(url, ...arguments),
    deleteV1BuildOrdersMaterialId: _deleteV1BuildOrdersMaterialId.bind(url, ...arguments),
    getV1BuildOrdersIdAccountingLedger: _getV1BuildOrdersIdAccountingLedger.bind(url, ...arguments),
    postV1BuildOrdersIdMaterialTracking: _postV1BuildOrdersIdMaterialTracking.bind(url, ...arguments),
    putV1BuildOrdersIdStatus: _putV1BuildOrdersIdStatus.bind(url, ...arguments),
    getV1BuildOrdersIdCostAnalysis: _getV1BuildOrdersIdCostAnalysis.bind(url, ...arguments),
    getV1BuildOrdersGenerateExcel: _getV1BuildOrdersGenerateExcel.bind(url, ...arguments),
    getV1BuildOrdersIdDownloadslitlabel: _getV1BuildOrdersIdDownloadslitlabel.bind(url, ...arguments),
    postV1BuildOrdersIdDownloadbyproductslitlabel: _postV1BuildOrdersIdDownloadbyproductslitlabel.bind(url, ...arguments),
    getV1JobCards: _getV1JobCards.bind(url, ...arguments),
    postV1JobCards: _postV1JobCards.bind(url, ...arguments),
    getV1JobCardsId: _getV1JobCardsId.bind(url, ...arguments),
    putV1JobCardsId: _putV1JobCardsId.bind(url, ...arguments),
    deleteV1JobCardsId: _deleteV1JobCardsId.bind(url, ...arguments),
    postV1JobCardsOperations: _postV1JobCardsOperations.bind(url, ...arguments),
    postV1JobCardsOperationsBatchAction: _postV1JobCardsOperationsBatchAction.bind(url, ...arguments),
    postV1JobCardsOperationsBulkOperations: _postV1JobCardsOperationsBulkOperations.bind(url, ...arguments),
    postV1JobCardsSaveAsDraft: _postV1JobCardsSaveAsDraft.bind(url, ...arguments),
    putV1JobCardsRoutingId: _putV1JobCardsRoutingId.bind(url, ...arguments),
    patchV1JobCardsStatusId: _patchV1JobCardsStatusId.bind(url, ...arguments),
    patchV1JobCardsRoutingStatusId: _patchV1JobCardsRoutingStatusId.bind(url, ...arguments),
    patchV1JobCardsRoutingEquipmentStatusId: _patchV1JobCardsRoutingEquipmentStatusId.bind(url, ...arguments),
    patchV1JobCardsRoutingBlockStatusId: _patchV1JobCardsRoutingBlockStatusId.bind(url, ...arguments),
    postV1JobCardsIdRecordCompletion: _postV1JobCardsIdRecordCompletion.bind(url, ...arguments),
    getV1JobCardsIdRecordCompletion: _getV1JobCardsIdRecordCompletion.bind(url, ...arguments),
    getV1JobCardsJobCardIdRecordCompletionSummaryId: _getV1JobCardsJobCardIdRecordCompletionSummaryId.bind(url, ...arguments),
    getV1JobCardsIdDownload: _getV1JobCardsIdDownload.bind(url, ...arguments),
    getV1JobCardsGenerateExcel: _getV1JobCardsGenerateExcel.bind(url, ...arguments),
    getV1JobCardsOperationsGenerateExcel: _getV1JobCardsOperationsGenerateExcel.bind(url, ...arguments),
    getV1Routing: _getV1Routing.bind(url, ...arguments),
    postV1Routing: _postV1Routing.bind(url, ...arguments),
    getV1RoutingId: _getV1RoutingId.bind(url, ...arguments),
    putV1RoutingId: _putV1RoutingId.bind(url, ...arguments),
    deleteV1RoutingId: _deleteV1RoutingId.bind(url, ...arguments),
    postV1RoutingSaveAsDraft: _postV1RoutingSaveAsDraft.bind(url, ...arguments),
    patchV1RoutingOperationId: _patchV1RoutingOperationId.bind(url, ...arguments),
    deleteV1RoutingOperationId: _deleteV1RoutingOperationId.bind(url, ...arguments),
    postV1RoutingOperation: _postV1RoutingOperation.bind(url, ...arguments),
    postV1RoutingImport: _postV1RoutingImport.bind(url, ...arguments),
    getV1RoutingGenerateExcel: _getV1RoutingGenerateExcel.bind(url, ...arguments),
    getV1WorkOrder: _getV1WorkOrder.bind(url, ...arguments),
    postV1WorkOrder: _postV1WorkOrder.bind(url, ...arguments),
    getV1WorkOrderId: _getV1WorkOrderId.bind(url, ...arguments),
    putV1WorkOrderId: _putV1WorkOrderId.bind(url, ...arguments),
    deleteV1WorkOrderId: _deleteV1WorkOrderId.bind(url, ...arguments),
    getV1WorkOrderIdAccountingLedger: _getV1WorkOrderIdAccountingLedger.bind(url, ...arguments),
    postV1WorkOrderIdMaterialTracking: _postV1WorkOrderIdMaterialTracking.bind(url, ...arguments),
    postV1WorkOrderSlit: _postV1WorkOrderSlit.bind(url, ...arguments),
    postV1WorkOrderScaffolding: _postV1WorkOrderScaffolding.bind(url, ...arguments),
    putV1WorkOrderByproductId: _putV1WorkOrderByproductId.bind(url, ...arguments),
    deleteV1WorkOrderByproductId: _deleteV1WorkOrderByproductId.bind(url, ...arguments),
    postV1WorkOrderIdValidate: _postV1WorkOrderIdValidate.bind(url, ...arguments),
    getV1WorkOrderIdMaterialIssued: _getV1WorkOrderIdMaterialIssued.bind(url, ...arguments),
    getV1WorkOrderIdMaterialIssuedIssueIdDownload: _getV1WorkOrderIdMaterialIssuedIssueIdDownload.bind(url, ...arguments),
    postV1WorkOrderMaterial: _postV1WorkOrderMaterial.bind(url, ...arguments),
    putV1WorkOrderMaterialId: _putV1WorkOrderMaterialId.bind(url, ...arguments),
    deleteV1WorkOrderMaterialId: _deleteV1WorkOrderMaterialId.bind(url, ...arguments),
    postV1WorkOrderSaveAsDraft: _postV1WorkOrderSaveAsDraft.bind(url, ...arguments),
    patchV1WorkOrderIdStatus: _patchV1WorkOrderIdStatus.bind(url, ...arguments),
    getV1WorkOrderIdCostAnalysis: _getV1WorkOrderIdCostAnalysis.bind(url, ...arguments),
    postV1WorkOrderImport: _postV1WorkOrderImport.bind(url, ...arguments),
    getV1WorkOrderIdScrap: _getV1WorkOrderIdScrap.bind(url, ...arguments),
    getV1WorkOrderIdDownload: _getV1WorkOrderIdDownload.bind(url, ...arguments),
    getV1WorkOrderGenerateExcel: _getV1WorkOrderGenerateExcel.bind(url, ...arguments),
    postV1WorkOrderDemandPlanningSaveAsDraft: _postV1WorkOrderDemandPlanningSaveAsDraft.bind(url, ...arguments),
    postV1UnbuildOrdersSaveDraft: _postV1UnbuildOrdersSaveDraft.bind(url, ...arguments),
    postV1UnbuildOrders: _postV1UnbuildOrders.bind(url, ...arguments),
    getV1UnbuildOrders: _getV1UnbuildOrders.bind(url, ...arguments),
    getV1UnbuildOrdersId: _getV1UnbuildOrdersId.bind(url, ...arguments),
    deleteV1UnbuildOrdersId: _deleteV1UnbuildOrdersId.bind(url, ...arguments),
    putV1UnbuildOrdersId: _putV1UnbuildOrdersId.bind(url, ...arguments),
    getV1UnbuildOrdersIdAccountingLedger: _getV1UnbuildOrdersIdAccountingLedger.bind(url, ...arguments),
    postV1UnbuildOrdersIdMaterial: _postV1UnbuildOrdersIdMaterial.bind(url, ...arguments),
    putV1UnbuildOrdersMaterialId: _putV1UnbuildOrdersMaterialId.bind(url, ...arguments),
    deleteV1UnbuildOrdersMaterialId: _deleteV1UnbuildOrdersMaterialId.bind(url, ...arguments),
    postV1UnbuildOrdersIdMaterialTracking: _postV1UnbuildOrdersIdMaterialTracking.bind(url, ...arguments),
    putV1UnbuildOrdersIdStatus: _putV1UnbuildOrdersIdStatus.bind(url, ...arguments),
    getV1UnbuildOrdersGenerateExcel: _getV1UnbuildOrdersGenerateExcel.bind(url, ...arguments),
    postV1OperationBlock: _postV1OperationBlock.bind(url, ...arguments),
    getV1OperationBlock: _getV1OperationBlock.bind(url, ...arguments),
    getV1OperationBlockId: _getV1OperationBlockId.bind(url, ...arguments),
    deleteV1OperationBlockId: _deleteV1OperationBlockId.bind(url, ...arguments),
    putV1OperationBlockId: _putV1OperationBlockId.bind(url, ...arguments),
    getV1OperationBlockGenerateExcel: _getV1OperationBlockGenerateExcel.bind(url, ...arguments),
    getV1Settings: _getV1Settings.bind(url, ...arguments),
    postV1Settings: _postV1Settings.bind(url, ...arguments),
    postV1ReportsRecordCompletionReport: _postV1ReportsRecordCompletionReport.bind(url, ...arguments),
    postV1ReportsFactoryDailyConsumptionReport: _postV1ReportsFactoryDailyConsumptionReport.bind(url, ...arguments),
    postV1ReportsScrapReport: _postV1ReportsScrapReport.bind(url, ...arguments),
    postV1ReportsComponentUsageReport: _postV1ReportsComponentUsageReport.bind(url, ...arguments),
    postV1ReportsBomInquiryReport: _postV1ReportsBomInquiryReport.bind(url, ...arguments),
    postV1ReportsDowntimeReport: _postV1ReportsDowntimeReport.bind(url, ...arguments),
    postV1ReportsWorkOrderStatusReport: _postV1ReportsWorkOrderStatusReport.bind(url, ...arguments),
    postV1ReportsCostRollupReport: _postV1ReportsCostRollupReport.bind(url, ...arguments),
    postV1ReportsRoutingSchedulerReport: _postV1ReportsRoutingSchedulerReport.bind(url, ...arguments),
    postV1ReportsWorkCenterSchedulerReport: _postV1ReportsWorkCenterSchedulerReport.bind(url, ...arguments),
    getV1ProductionPlan: _getV1ProductionPlan.bind(url, ...arguments),
    postV1ProductionPlan: _postV1ProductionPlan.bind(url, ...arguments),
    getV1ProductionPlanId: _getV1ProductionPlanId.bind(url, ...arguments),
    deleteV1ProductionPlanId: _deleteV1ProductionPlanId.bind(url, ...arguments),
    patchV1ProductionPlanIdProductionPlanItem: _patchV1ProductionPlanIdProductionPlanItem.bind(url, ...arguments),
    postV1ProductionPlanCheckAvailability: _postV1ProductionPlanCheckAvailability.bind(url, ...arguments),
    postV1ProductionPlanFetchAvailability: _postV1ProductionPlanFetchAvailability.bind(url, ...arguments),
    postV1ProductionPlanTraceRawMatterial: _postV1ProductionPlanTraceRawMatterial.bind(url, ...arguments),
    postV1SlitPlanProvideDetails: _postV1SlitPlanProvideDetails.bind(url, ...arguments),
    getV1SlitPlanSummary: _getV1SlitPlanSummary.bind(url, ...arguments),
    getV1SlitPlanId: _getV1SlitPlanId.bind(url, ...arguments),
    putV1SlitPlanId: _putV1SlitPlanId.bind(url, ...arguments),
    deleteV1SlitPlanId: _deleteV1SlitPlanId.bind(url, ...arguments),
    getV1SlitPlanIdMaterialTracking: _getV1SlitPlanIdMaterialTracking.bind(url, ...arguments),
    postV1SlitPlanCreate: _postV1SlitPlanCreate.bind(url, ...arguments),
    postV1SlitPlanSaveAsDraft: _postV1SlitPlanSaveAsDraft.bind(url, ...arguments),
    postV1SlitPlanIdSlitItem: _postV1SlitPlanIdSlitItem.bind(url, ...arguments),
    patchV1SlitPlanSlitItemId: _patchV1SlitPlanSlitItemId.bind(url, ...arguments),
    deleteV1SlitPlanSlitItemId: _deleteV1SlitPlanSlitItemId.bind(url, ...arguments),
    postV1SlitPlanGetRawMaterialByType: _postV1SlitPlanGetRawMaterialByType.bind(url, ...arguments),
    getV1SlitPlanSlitAssemblyItemId: _getV1SlitPlanSlitAssemblyItemId.bind(url, ...arguments),
    getV1SlitPlanIdDownload: _getV1SlitPlanIdDownload.bind(url, ...arguments),
    postV1SlitPlanAddApprover: _postV1SlitPlanAddApprover.bind(url, ...arguments),
    putV1SlitPlanApprovalStatusId: _putV1SlitPlanApprovalStatusId.bind(url, ...arguments),
    getV1ScaffoldingPlanSummary: _getV1ScaffoldingPlanSummary.bind(url, ...arguments),
    getV1ScaffoldingPlanId: _getV1ScaffoldingPlanId.bind(url, ...arguments),
    putV1ScaffoldingPlanId: _putV1ScaffoldingPlanId.bind(url, ...arguments),
    deleteV1ScaffoldingPlanId: _deleteV1ScaffoldingPlanId.bind(url, ...arguments),
    getV1ScaffoldingPlanIdMaterialTracking: _getV1ScaffoldingPlanIdMaterialTracking.bind(url, ...arguments),
    postV1ScaffoldingPlanCreate: _postV1ScaffoldingPlanCreate.bind(url, ...arguments),
    postV1ScaffoldingPlanSaveAsDraft: _postV1ScaffoldingPlanSaveAsDraft.bind(url, ...arguments),
    postV1ScaffoldingPlanIdScaffoldingItem: _postV1ScaffoldingPlanIdScaffoldingItem.bind(url, ...arguments),
    patchV1ScaffoldingPlanScaffoldingItemId: _patchV1ScaffoldingPlanScaffoldingItemId.bind(url, ...arguments),
    deleteV1ScaffoldingPlanScaffoldingItemId: _deleteV1ScaffoldingPlanScaffoldingItemId.bind(url, ...arguments),
    postV1ScaffoldingPlanGetRawMaterialByType: _postV1ScaffoldingPlanGetRawMaterialByType.bind(url, ...arguments),
    getV1ScaffoldingPlanIdDownload: _getV1ScaffoldingPlanIdDownload.bind(url, ...arguments),
    postV1ScaffoldingPlanAddApprover: _postV1ScaffoldingPlanAddApprover.bind(url, ...arguments),
    putV1ScaffoldingPlanApprovalStatusId: _putV1ScaffoldingPlanApprovalStatusId.bind(url, ...arguments),
    getV1GateRegister: _getV1GateRegister.bind(url, ...arguments),
    postV1GateRegister: _postV1GateRegister.bind(url, ...arguments),
    getV1GateRegisterId: _getV1GateRegisterId.bind(url, ...arguments),
    putV1GateRegisterId: _putV1GateRegisterId.bind(url, ...arguments),
    deleteV1GateRegisterId: _deleteV1GateRegisterId.bind(url, ...arguments),
    getV1GateRegisterVehicleNumbers: _getV1GateRegisterVehicleNumbers.bind(url, ...arguments),
    postV1GateRegisterVehicleNumbers: _postV1GateRegisterVehicleNumbers.bind(url, ...arguments),
    getV1GateRegisterVehicleTypes: _getV1GateRegisterVehicleTypes.bind(url, ...arguments),
    postV1GateRegisterVehicleTypes: _postV1GateRegisterVehicleTypes.bind(url, ...arguments),
    getV1GateRegisterGenerateExcel: _getV1GateRegisterGenerateExcel.bind(url, ...arguments)
  }
}